import React, { createContext, useContext, useState, useEffect } from 'react';

const TranslationContext = createContext();

const translations = {
  en: {
    // CMS Navigation
    'nav.dashboard': 'Dashboard',
    'nav.analytics': 'Analytics',
    'nav.operations': 'Operations',
    'nav.collections': 'Collections',
    'nav.collections_dashboard': 'Dashboard',
    'nav.accounts': 'Accounts',
    'nav.new_account': 'New Account',
    'nav.approvals': 'Approvals',
    'nav.commissions': 'Commissions',
    'nav.commission_config': 'Commission Config',
    'nav.voice_settings': 'Voice Settings',
    'nav.disputes': 'Disputes',
    'nav.clients': 'Clients',
    'nav.all_clients': 'All Clients',
    'nav.outsourcing': 'Outsourcing',
    'nav.outsourcing_dashboard': 'Dashboard',
    'nav.inquiries': 'Inquiries',
    'nav.partners_list': 'Partners',
    'nav.escalations': 'Escalations',
    'nav.work_logs': 'Work Logs',
    'nav.invoices': 'Invoices',
    'nav.legal': 'Legal',
    'nav.attorney_marketplace': 'Attorney Marketplace',
    'nav.case_management': 'Case Management',
    'nav.submit_case': 'Submit Case',
    'nav.attorney_network': 'Attorney Network',
    'nav.penalties': 'Penalties',
    'nav.revenue_splits': 'Revenue Splits',
    'nav.lawsuits_filed': 'Lawsuits Filed',
    'nav.marketing': 'Marketing',
    'nav.website': 'Website',
    'nav.pages': 'Pages',
    'nav.blog': 'Blog',
    'nav.faqs': 'FAQs',
    'nav.press_releases': 'Press Releases',
    'nav.legal_pages': 'Legal Pages',
    'nav.banners_popups': 'Banners & Popups',
    'nav.media_library': 'Media Library',
    'nav.education_hub': 'Education Hub',
    'nav.reviews_social': 'Reviews & Social Proof',
    'nav.reviews': 'Reviews',
    'nav.outsource_reviews': 'Outsource Reviews',
    'nav.categories': 'Categories',
    'nav.hr_payroll': 'HR & Payroll',
    'nav.team_management': 'Team Management',
    'nav.authors_profiles': 'Authors / Profiles',
    'nav.payroll': 'Payroll',
    'nav.training': 'Training',
    'nav.security': 'Security',
    'nav.finance': 'Finance',
    'nav.billing': 'Billing',
    'nav.partners': 'Partners',
    'nav.affiliates_partners': 'Affiliates & Partners',
    'nav.tools': 'Tools',
    'nav.chat_support': 'Chat & Support',
    'nav.team_chat': 'Team Chat',
    'nav.customer_support': 'Customer Support',
    'nav.document_center': 'Document Center',
    'nav.admin': 'Admin',
    'nav.access_control': 'Access Control',
    'nav.site_settings': 'Site Settings',
    'nav.marketplace_mgmt': 'Marketplace Mgmt',
    'nav.view_site': 'View Site',
    'nav.affiliate_leads': 'Affiliate Leads',
    'nav.comparisons': 'Comparisons',
    'nav.credlocity_partners': 'Credlocity Partners',
    'nav.add_partner': 'Add Partner',
    'nav.forms_calendars': 'Forms & Calendars',
    'nav.intake_forms': 'Intake Forms',
    'nav.calendars': 'Calendars',
    'nav.settings': 'Settings',
    'nav.lawsuit_config': 'Lawsuit Config',
    'nav.complaints': 'Complaints',
    'nav.outsource_reviews': 'Outsource Reviews',
    'nav.welcome': 'Welcome to Credlocity CMS',
    'nav.welcome_sub': 'Manage your content, partners, and business operations',
    'nav.quick_actions': 'Quick Actions',
    'nav.new_blog_post': 'New Blog Post',
    'nav.add_lawsuit': 'Add Lawsuit',
    'nav.manage_partners': 'Manage Partners',
    'nav.add_review': 'Add Review',

    // Dashboard KPIs
    'kpi.content_overview': 'Content Overview',
    'kpi.collections_revenue': 'Collections & Revenue',
    'kpi.hr_payroll': 'HR & Payroll',
    'nav.lawsuits_filed': 'Lawsuits Filed',
    'nav.marketing': 'Marketing',
    'nav.website': 'Website',
    'nav.reviews_social': 'Reviews & Social Proof',
    'nav.hr_payroll': 'HR & Payroll',
    'nav.team_management': 'Team Management',
    'nav.authors_profiles': 'Authors / Profiles',
    'nav.payroll': 'Payroll',
    'nav.training': 'Training',
    'nav.security': 'Security',
    'nav.finance': 'Finance',
    'nav.billing': 'Billing',
    'nav.partners': 'Partners',
    'nav.affiliates_partners': 'Affiliates & Partners',
    'nav.tools': 'Tools',
    'nav.chat_support': 'Chat & Support',
    'nav.team_chat': 'Team Chat',
    'nav.customer_support': 'Customer Support',
    'nav.document_center': 'Document Center',
    'nav.admin': 'Admin',
    'nav.access_control': 'Access Control',
    'nav.site_settings': 'Site Settings',
    'nav.marketplace_mgmt': 'Marketplace Mgmt',
    'nav.view_site': 'View Site',

    // Dashboard KPIs
    'kpi.total_content': 'Total Content',
    'kpi.blog_posts': 'Blog Posts',
    'kpi.pages': 'Pages',
    'kpi.faqs': 'FAQs',
    'kpi.media': 'Media Files',
    'kpi.team_members': 'Team Members',
    'kpi.reviews': 'Reviews',
    'kpi.active_accounts': 'Active Accounts',
    'kpi.total_owed': 'Total Owed',
    'kpi.commissions_earned': 'Commissions Earned',
    'kpi.pending_commissions': 'Pending Commissions',
    'kpi.employees': 'Employees',
    'kpi.annual_salaries': 'Annual Salaries',
    'kpi.monthly_commissions': 'Monthly Commissions',
    'kpi.bonuses': 'Bonuses',
    'kpi.active_lawsuits': 'Active Lawsuits',
    'kpi.marketplace_cases': 'Marketplace Cases',
    'kpi.attorney_network': 'Attorney Network',
    'kpi.total_clients': 'Total Clients',
    'kpi.active_cases': 'Active Cases',
    'kpi.recent_submissions': 'Recent Submissions',

    // Dashboard Home
    'dashboard.recent_posts': 'Recent Blog Posts',
    'dashboard.view_all': 'View All',
    'dashboard.system_status': 'System Status',
    'dashboard.quick_links': 'Quick Links',
    'dashboard.no_posts': 'No blog posts yet',
    'dashboard.create_first': 'Create your first post',
    'dashboard.legal_content': 'Legal Content',
    'dashboard.outsourcing': 'Outsourcing',
    'dashboard.clients': 'Clients',
    'dashboard.active_partners': 'Active Partners',
    'dashboard.pending_inquiries': 'Pending Inquiries',
    'dashboard.open_tickets': 'Open Tickets',
    'dashboard.commission_earned': 'Commission Earned',
    'dashboard.active_trackers': 'Active Trackers',
    'dashboard.active_employees': 'Active Employees',
    'dashboard.training_modules': 'Training Modules',
    'dashboard.lawsuits_filed': 'Lawsuits Filed',
    'dashboard.press_releases': 'Press Releases',
    'dashboard.hot_leads': 'Hot Leads',
    'dashboard.new_30_days': 'New (30 days)',
    'dashboard.website': 'Website',
    'dashboard.online': 'Online',
    'dashboard.api': 'API',
    'dashboard.operational': 'Operational',
    'dashboard.database': 'Database',
    'dashboard.connected': 'Connected',
    'dashboard.media_library': 'Media Library',
    'dashboard.site_settings': 'Site Settings',
    'dashboard.needs_attention': 'Needs attention',
    'dashboard.all_caught_up': 'All caught up!',
    'dashboard.escalations': 'Escalations',
    'dashboard.no_open_tickets': 'No open tickets',
    'dashboard.ready_to_convert': 'Ready to convert',
    'dashboard.no_hot_leads': 'No hot leads',
    'dashboard.dashboard': 'Dashboard',
    'dashboard.view': 'View',
    'dashboard.collections': 'Collections',
    'dashboard.threshold_tracking': '70% threshold tracking',

    // Common UI
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.submit': 'Submit',
    'common.refresh': 'Refresh',
    'common.loading': 'Loading...',
    'common.no_results': 'No results found',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.all': 'All',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.department': 'Department',
    'common.role': 'Role',
    'common.type': 'Type',
    'common.date': 'Date',
    'common.back': 'Back',
    'common.view': 'View',
    'common.download': 'Download',
    'common.upload': 'Upload',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.apply': 'Apply',

    // Employee Directory
    'team.title': 'Employee Directory',
    'team.subtitle': 'Manage your team members, roles, and departments',
    'team.add_employee': 'Add Employee',
    'team.total_members': 'Total Members',
    'team.employees': 'Employees',
    'team.contractors': 'Contractors',
    'team.departments': 'Departments',
    'team.search_placeholder': 'Search by name or email...',
    'team.all_roles': 'All Roles',
    'team.all_types': 'All Types',
    'team.back_to_directory': 'Back to Directory',
    'team.org_chart': 'Org Chart',
    'team.contact': 'Contact',
    'team.employment': 'Employment',
    'team.training_progress': 'Training Progress',
    'team.emergency_contact': 'Emergency Contact',
    'team.skills': 'Skills & Expertise',
    'team.about': 'About',
    'team.admin_notes': 'Admin Notes',
    'team.hire_date': 'Hire Date',
    'team.birthday': 'Birthday',
    'team.tenure': 'Tenure',
    'team.full_name': 'Full Name',
    'team.job_title': 'Job Title',
    'team.location': 'Location',
    'team.bio': 'Bio',
    'team.linkedin': 'LinkedIn URL',
    'team.profile_photo': 'Profile Photo',
    'team.password': 'Password',

    // Homepage
    'home.hero_title': 'CREDIT REPAIR DONE RIGHT',
    'home.hero_subtitle': 'Remove Negative Items, Collections & Late Payments From Your Credit Report',
    'home.hero_desc': 'Professional credit repair services helping you improve your credit score and achieve financial freedom. Serving clients nationwide since 2008.',
    'home.start_free_trial': 'Start Your Free 30-Day Trial',
    'home.book_consultation': 'Book Free Consultation',
    'home.day_free_trial': 'Day Free Trial',
    'home.longest_industry': 'Longest in Industry',
    'home.first_work_fee': 'First Work Fee',
    'home.no_upfront': 'No Upfront Costs',
    'home.how_title': 'How to Repair Your Credit: The Complete Process',
    'home.how_desc': "Over 79,000 Americans have improved their credit scores using proven credit repair strategies. Whether you repair your credit yourself or work with professionals, understanding the process is essential. Here's everything you need to know about legally removing negative items, improving your credit score, and achieving financial freedom.",
    'home.step1_title': 'Step 1: Obtain Your Credit Reports',
    'home.step1_desc': 'Get free copies from AnnualCreditReport.com or through Experian, Equifax, and TransUnion. Review all three reports carefully for errors, outdated information, and inaccurate negative items.',
    'home.step2_title': 'Step 2: Identify Disputable Items',
    'home.step2_desc': 'Look for:',
    'home.step2_b1': "Accounts you don't recognize",
    'home.step2_b2': 'Incorrect late payment dates',
    'home.step2_b3': 'Collections beyond the 7-year reporting period',
    'home.step2_b4': 'Duplicate accounts',
    'home.step2_b5': 'Incorrect balances or credit limits',
    'home.step2_b6': 'Identity theft items',
    'home.step3_title': 'Step 3: File Disputes Under FCRA',
    'home.step3_desc': 'The Fair Credit Reporting Act (FCRA) gives you the right to dispute any inaccurate, incomplete, or unverifiable information. Credit bureaus must investigate within 30 days.',
    'home.step4_title': 'Step 4: Challenge Unverified Items',
    'home.step4_desc': "If creditors can't verify the disputed information, the credit bureau must remove it. Professional credit repair companies use advanced strategies including Metro2 compliance checks and FCRA violation identification.",
    'home.step5_title': 'Step 5: Monitor Progress',
    'home.step5_desc': 'Track your credit score changes monthly. Most people see improvements within 60-90 days of starting the dispute process.',
    'home.professional_title': 'When to Consider Professional Credit Repair',
    'home.professional_desc': 'While you can repair credit yourself, professional credit repair services save time and often achieve better results through:',
    'home.pro_b1': "Advanced dispute strategies you can't access as a consumer",
    'home.pro_b2': 'Legal expertise in FCRA, FDCPA, and FCBA violations',
    'home.pro_b3': 'Creditor negotiations and pay-for-delete arrangements',
    'home.pro_b4': 'Bureau challenges using technical Metro2 compliance issues',
    'home.pro_b5': 'Litigation support for FCRA violations',
    'home.get_professional_help': 'Get Professional Help',
    'home.why_title': 'Why Choose Credlocity Over Other Credit Repair Companies',
    'home.why_desc': "Not all credit repair companies are created equal. Here's what makes us different from Lexington Law, Credit Saint, The Credit People, and other competitors.",
    'home.feat_ai_title': 'Advanced AI Technology',
    'home.feat_ai_desc': 'Our proprietary AI analyzes your credit reports using Metro2 compliance standards and creates personalized dispute strategies targeting FCRA, FDCPA, and FCBA violations for maximum effectiveness.',
    'home.feat_tsr_title': 'TSR Compliant Process',
    'home.feat_tsr_desc': '100% compliant with federal regulations. No phone enrollment, secure online platform only.',
    'home.feat_hispanic_title': 'Hispanic-Owned Business',
    'home.feat_hispanic_desc': 'Founded by CEO Joeziel Vazquez in Philadelphia, serving diverse communities across all 50 states.',
    'home.feat_proven_title': 'Proven Track Record',
    'home.feat_proven_desc': '16+ years experience, 79,000+ clients served, and thousands of success stories.',
    'home.feat_certified_title': 'Certified Credit Experts',
    'home.feat_certified_desc': 'Board Certified Credit Consultant (BCCC), Certified Credit Score Consultant (CCSC), and FCRA Certified professionals with 16+ years of experience.',
    'home.compare': 'Compare us to competitors:',
    'home.years_exp': 'Years of Experience',
    'home.users': 'Users',
    'home.deleted_debt': 'Deleted Debt',
    'home.trial_title': '30-Day Free Trial',
    'home.trial_desc': 'Experience our service risk-free with our comprehensive guarantee package',
    'home.trial_b1': '$0 due today - start immediately',
    'home.trial_b2': '180-day money-back guarantee',
    'home.trial_b3': 'Cancel anytime, no long-term contracts',
    'home.trial_b4': 'Free Credit Tracker app included',
    'home.trial_disclaimer': '*You will pay for your credit report ($49.95) once you meet your assigned credit repair agent. Credit card information required but not charged for service fee for 30 days.',
    'home.start_trial': 'Start Your Free Trial',
    'home.required_services': 'Required Services',
    'home.credit_analysis': 'Credit Report Analysis',
    'home.analysis_b1': 'Comprehensive review of all three credit reports',
    'home.analysis_b2': 'Full Experian, Equifax & TransUnion review',
    'home.analysis_b3': 'Identification of all negative items',
    'home.analysis_b4': 'Personalized action plan',
    'home.poa_title': 'Power of Attorney (E-Notary)',
    'home.poa_b1': 'Electronic notarization included',
    'home.poa_b2': 'Legal authority to dispute on your behalf',
    'home.poa_b3': 'Required for bureau communications',
    'home.issues_title': 'Credit Issues We Fix',
    'home.issues_desc': 'Expert removal strategies for every type of negative item affecting your credit score.',
    'home.issue_collection': 'Collection Removal',
    'home.issue_collection_desc': 'Remove collection accounts using FDCPA violations, validation disputes, and pay-for-delete negotiations. Collections can drop your score 50-100 points—we remove them permanently.',
    'home.issue_late': 'Late Payment Removal',
    'home.issue_late_desc': 'Remove late payments through goodwill letters, FCBA disputes, and Metro2 compliance challenges. Even one 30-day late can cost you 60-110 points.',
    'home.issue_chargeoff': 'Charge-Off Removal',
    'home.issue_chargeoff_desc': 'Remove charge-offs using verification disputes, account validation, and creditor negotiations. Charge-offs signal severe delinquency to lenders.',
    'home.issue_bankruptcy': 'Bankruptcy Removal',
    'home.issue_bankruptcy_desc': 'Challenge bankruptcy reporting errors and rebuild credit after Chapter 7 or Chapter 13. While bankruptcies are difficult to remove, errors in reporting are common.',
    'home.issue_identity': 'Identity Theft Resolution',
    'home.issue_identity_desc': 'Expert FCRA 605B credit block process for fraud victims. Remove fraudulent accounts and restore your credit using specialized identity theft procedures.',
    'home.issue_inquiry': 'Hard Inquiry Removal',
    'home.issue_inquiry_desc': "Remove unauthorized hard inquiries that weren't approved by you. Each inquiry can cost 5-10 points, and multiple inquiries compound the damage.",
    'home.learn_more': 'Learn More',
    'home.process_title': 'Our Proven 6-Step Process',
    'home.process_desc': "We've perfected our credit repair process over 16+ years to deliver maximum results for our clients.",
    'home.ps1_title': 'Free Credit Analysis',
    'home.ps1_desc': 'Complete credit report review to identify all negative items and opportunities for improvement.',
    'home.ps2_title': 'Custom Strategy',
    'home.ps2_desc': 'Personalized dispute strategy using advanced AI and Metro2 compliance techniques.',
    'home.ps3_title': 'Professional Disputes',
    'home.ps3_desc': 'Expert dispute letters sent to credit bureaus and creditors on your behalf.',
    'home.ps4_title': 'Bureau Challenges',
    'home.ps4_desc': 'Strategic challenges to all three credit bureaus using proven legal methods.',
    'home.ps5_title': 'Progress Tracking',
    'home.ps5_desc': 'Real-time updates via our Credit Tracker app showing your improving scores.',
    'home.ps6_title': 'Score Optimization',
    'home.ps6_desc': 'Ongoing optimization and credit building strategies for long-term success.',
    'home.testimonials_title': 'Real Results from Real Clients',
    'home.testimonials_desc': "Don't just take our word for it. See what our clients are saying about their credit repair journey.",
    'home.before': 'Before',
    'home.after': 'After',
    'home.read_story': 'Read Full Story',
    'home.local_title': 'Credit Repair Services in Philadelphia & Nationwide',
    'home.local_desc': "Since 2008, Credlocity has operated from our Philadelphia, Pennsylvania headquarters, providing professional credit repair services to clients across all 50 states. As a Hispanic-owned business founded by CEO Joeziel Vazquez, we're proud to serve diverse communities with ethical, compliant credit restoration services.",
    'home.serving_markets': 'Serving These Major Markets:',
    'home.get_started_online': 'Get Started Online',
    'home.philly_hq': 'Philadelphia Headquarters',
    'home.serving_50': 'Serving all 50 states nationwide',
    'home.email_support': 'Email Support',
    'home.tsr_compliant': 'TSR Compliant',
    'home.tsr_online': '100% online enrollment - No phone calls required',
    'home.signup_anytime': 'Sign Up Anytime',
    'home.247_enrollment': '24/7 online enrollment available',
    'home.start_trial_online': 'Start Your Free Trial Online',
    'home.faq_title': 'Common Questions About Credit Repair',
    'home.faq_desc': 'Get answers to the most frequently asked questions about our credit repair services.',
    'home.faq1_q': 'How long does credit repair take?',
    'home.faq1_a': 'Most clients see results within 60-90 days, with significant improvements by 6 months. The timeline depends on the number and type of negative items. Collections and late payments are often removed faster than bankruptcies or judgments. Credit bureaus have 30 days to investigate disputes under FCRA.',
    'home.faq2_q': 'Can you really remove negative items from my credit report?',
    'home.faq2_a': 'Yes, but only items that are inaccurate, unverifiable, or violate consumer protection laws. Legitimate negative information that creditors can verify may remain. However, many negative items contain errors or compliance violations that make them legally removable under FCRA, FDCPA, or FCBA.',
    'home.faq3_q': 'How much does credit repair cost?',
    'home.faq3_a': 'Credit repair typically costs $79-$149 per month. Credlocity offers a 30-day free trial with no upfront service fees. You only pay for required services: credit report analysis ($49.95) and power of attorney e-notary ($39.95). After your free trial, monthly service is $99/month with our 180-day money-back guarantee.',
    'home.faq4_q': 'Is credit repair legal?',
    'home.faq4_a': 'Yes. Credit repair is 100% legal under the Credit Repair Organizations Act (CROA). You have the right to dispute inaccurate information under the Fair Credit Reporting Act (FCRA). Reputable companies like Credlocity operate in full compliance with federal regulations including TSR and CROA.',
    'home.faq5_q': 'Will credit repair hurt my credit score?',
    'home.faq5_a': 'No. Disputing items cannot hurt your credit score. If a dispute is successful, negative items are removed and your score improves. If unsuccessful, your credit stays the same. There is no downside to legitimate credit repair disputes.',
    'home.faq_more': 'Have more questions? Visit our comprehensive FAQ page with 50+ answers.',
    'home.view_all_faqs': 'View All FAQs',
    'home.cta_title': 'Ready to Take Control of Your Credit?',
    'home.cta_desc': 'Start your 30-day free trial today. No credit card required. No first work fee. Cancel anytime.',
    'home.cta_trial': 'Start Your Free Trial',
    'home.cta_consult': 'Book a Consultation',

    // Public website
    'site.home': 'Home',
    'site.about': 'About',
    'site.about_us': 'About Us',
    'site.services': 'Services',
    'site.resources': 'Resources',
    'site.contact': 'Contact',
    'site.login': 'Login',
    'site.get_started': 'Get Started',
    'site.learn_more': 'Learn More',
    'site.credit_repair': 'Credit Repair',
    'site.debt_collection': 'Debt Collection',
    'site.legal_services': 'Legal Services',
    'site.education': 'Education',
    'site.blog': 'Blog',
    'site.faq': 'FAQ',
    'site.privacy_policy': 'Privacy Policy',
    'site.terms_of_service': 'Terms of Service',
    'site.all_rights_reserved': 'All rights reserved',
    'site.plans_pricing': 'Plans & Pricing',
    'site.why_us': 'Why Us',
    'site.free_trial': '30 Day Free Trial',
    'site.collection_removal': 'Collection Removal',
    'site.late_payment_removal': 'Late Payment Removal',
    'site.fraud_removal': 'Fraud Removal',
    'site.human_trafficking_block': 'Human Trafficking Credit Block',
    'site.how_it_works': 'How It Works',
    'site.faqs': 'FAQs',
    'site.our_team': 'Our Team',
    'site.educational_guides': 'Educational Guides',
    'site.credit_repair_scams': 'Credit Repair Scam Info',
    'site.credit_tracker': 'Credit Tracker App',
    'site.start_free_trial': 'Start Free Trial',

    // Footer
    'footer.tagline': "America's Most Trusted Credit Repair Company",
    'footer.credit_education': 'Credit Education',
    'footer.credit_scores': 'Credit Scores',
    'footer.credit_reports': 'Credit Reports',
    'footer.repair_methods': 'Repair Methods',
    'footer.debt_management': 'Debt Management',
    'footer.credit_building': 'Credit Building',
    'footer.financial_wellness': 'Financial Wellness',
    'footer.education_hub': 'Education Hub',
    'footer.fcra_guide': 'FCRA Guide',
    'footer.fdcpa_guide': 'FDCPA Guide',
    'footer.croa_guide': 'CROA Guide',
    'footer.tsr_compliance': 'TSR Compliance',
    'footer.fcra_605b': 'FCRA 605B Block',
    'footer.vs_competitors': 'Credlocity vs. Competitors',
    'footer.credit_repair_reviews': 'Credit Repair Reviews',
    'footer.why_us_over_them': 'Why Us Over Them',
    'footer.credlocity': 'Credlocity',
    'footer.success_stories': 'Success Stories',
    'footer.lawsuits_filed': 'Lawsuits Filed',
    'footer.press_releases': 'Press Releases',
    'footer.credlocity_partners': 'Credlocity Partners',
    'footer.become_partner': 'Become a Partner',
    'footer.outsourcing_services': 'Outsourcing Services',
    'footer.credit_tools': 'Credit Tools',
    'footer.credit_score_calc': 'Credit Score Calculator',
    'footer.dti_calc': 'Debt-to-Income Calculator',
    'footer.utilization_calc': 'Credit Utilization Calculator',
    'footer.loan_calc': 'Loan Payment Calculator',
    'footer.debt_payoff_calc': 'Debt Payoff Calculator',
    'footer.mortgage_calc': 'Mortgage Calculator',
    'footer.cc_payoff_calc': 'Credit Card Payoff Calculator',
    'footer.savings_calc': 'Savings Calculator',
    'footer.interest_calc': 'Interest Calculator',
    'footer.budget_calc': 'Budget Calculator',
    'footer.refinance_calc': 'Refinance Calculator',
    'footer.student_loan_calc': 'Student Loan Calculator',
    'footer.auto_loan_calc': 'Auto Loan Calculator',
    'footer.retirement_calc': 'Retirement Calculator',
    'footer.consumer_protection': 'Consumer Protection',
    'footer.report_fraud': 'Report Fraud',
    'footer.report_fraud_desc': 'State Attorney General or local consumer affairs',
    'footer.ftc_complaints': 'FTC Complaints',
    'footer.unfair_treatment': 'Unfair Treatment',
    'footer.unfair_treatment_desc': 'Contact PA Attorney General',
    'footer.honest_fair_legal': 'Honest, Fair & Legal',
    'footer.important_disclosure': 'IMPORTANT DISCLOSURE',
    'footer.your_rights': 'Your Rights',
    'footer.your_rights_desc': 'You can dispute credit report errors for free under the Fair Credit Reporting Act (FCRA). Credlocity does not provide legal advice or guarantee removal of verifiable items.',
    'footer.requirements': 'Requirements',
    'footer.requirements_desc': 'Active client participation required. Results may vary. We comply with all federal and state credit repair laws.',
    'footer.tsr_compliance_title': 'TSR Compliance',
    'footer.tsr_compliance_desc': 'Full compliance with CROA and Telemarketing Sales Rule.',
    'footer.federal_notice': 'Federal Notice',
    'footer.federal_notice_desc': 'All services initiated through secure online platform. Per federal regulations, no phone enrollment.',
    'footer.our_promise': 'Our Promise',
    'footer.our_promise_desc': 'Committed to ethical practices and complete transparency in all our services.',
    'footer.report_fraud_title': 'Report Fraud',
    'footer.report_fraud_question': 'Had a bad experience with another credit repair company?',
    'footer.submit_complaint': 'Submit a Complaint',
    'footer.copyright': '2026 Credlocity Business Group LLC. All rights reserved.',
    'footer.serving': 'Serving All 50 States from Philadelphia, PA',

    // Login pages — shared
    'login.email': 'Email',
    'login.password': 'Password',
    'login.sign_in': 'Sign In',
    'login.signing_in': 'Signing in...',
    'login.forgot_password': 'Forgot password?',
    'login.remember_me': 'Remember me',
    'login.send_reset': 'Send Reset Email',
    'login.sending': 'Sending...',
    'login.reset_sent': 'If that email exists, a reset was sent.',
    'login.back_to_login': '← Back to login',
    'login.back_to_home': 'Back to Credlocity Home',

    // CRO login
    'cro.portal_title': 'CRO Partner Portal',
    'cro.portal_subtitle': 'Sign in to manage your cases and earnings',
    'cro.not_partner': 'Not a partner yet?',
    'cro.apply_network': 'Apply to join our network',
    'cro.forgot_desc': "Enter your CRO account email and we'll send a temporary password.",

    // CRO Dashboard
    'cro.dashboard.welcome_back': 'Welcome back',
    'cro.dashboard.overview': "Here's your CRO partnership overview.",
    'cro.showcase.eyebrow': 'Recovered for clients',
    'cro.showcase.label': 'Total recovered for your clients',
    'cro.showcase.sub_one': 'Across 1 settled case',
    'cro.showcase.sub_many': 'Across {count} settled cases',
    'cro.showcase.empty_headline': 'Recovering money for your clients',
    'cro.showcase.empty_sub': "Your clients' recoveries will appear here as your submitted cases settle.",
    'cro.dashboard.total_cases': 'Total Cases',
    'cro.dashboard.all_submissions': 'All submissions',
    'cro.dashboard.active_cases': 'Active Cases',
    'cro.dashboard.in_marketplace': 'In marketplace',
    'cro.dashboard.total_earnings': 'Total Earnings',
    'cro.dashboard.all_time': 'All time',
    'cro.dashboard.pending_payouts': 'Pending Payouts',
    'cro.dashboard.processing': 'Processing',
    'cro.dashboard.rejected_cases': 'Rejected Cases',
    'cro.dashboard.unread_messages': 'Unread Messages',
    'cro.dashboard.recent_cases': 'Recent Cases',
    'cro.dashboard.latest_submissions': 'Your latest case submissions',
    'cro.dashboard.view_all': 'View All',
    'cro.dashboard.no_cases': 'No cases submitted yet',
    'cro.dashboard.submit_first': 'Submit Your First Case',
    'cro.dashboard.quick_actions': 'Quick Actions',
    'cro.dashboard.submit_new_case': 'Submit New Case',
    'cro.dashboard.track_cases': 'Track My Cases',
    'cro.dashboard.view_earnings': 'View Earnings',
    'cro.dashboard.messages': 'Messages',
    'cro.dashboard.case_pipeline': 'Case Pipeline',
    'cro.dashboard.pending_review': 'Pending Review',
    'cro.dashboard.listed_bidding': 'Listed / Bidding',
    'cro.dashboard.pledged': 'Pledged',
    'cro.dashboard.awarded': 'Awarded',
    'cro.dashboard.est_value': 'Est. Value:',
    'cro.dashboard.view': 'View',
    'cro.dashboard.error': 'Error',
    'cro.dashboard.try_again': 'Try Again',
    'cro.dashboard.cro_portal': 'CRO Portal',
    'cro.dashboard.account_settings': 'Account Settings',
    'cro.dashboard.subscription': 'Subscription',
    'cro.dashboard.logout': 'Logout',
    'cro.dashboard.how_it_works': 'How It Works',

    // CRO Fee Agreement Modal
    'cro.agreement.title': 'CRO Partner Agreement v2.0',
    'cro.agreement.subtitle': 'Review and sign to access your portal',
    'cro.agreement.sign_label': 'Type your full name to sign',
    'cro.agreement.sign_placeholder': 'e.g. Jane M. Smith',
    'cro.agreement.signing': 'Signing...',
    'cro.agreement.agree_sign': 'I Agree and Sign',
    'cro.agreement.failed': 'Failed to submit. Please try again.',
    'cro.agreement.network_error': 'Network error. Please try again.',

    // CRO How It Works Modal
    'cro.how.title': 'How the Attorney Marketplace Works for You',
    'cro.how.platform_access': 'Platform Access Fees',
    'cro.how.platform_fee_detail': 'One-time signup fee: {signup} ({waiver} for active outsourcing clients with {threshold}+ consumers enrolled). Monthly fee: {monthly}/month, starting after a {new_free_days}-day free period (outsourcing clients with {threshold}+ consumers enrolled get {partner_free_days} days free).',
    'cro.how.submitting_cases': 'Submitting Cases',
    'cro.how.submitting_detail': 'From your dashboard, submit consumer cases to the Credlocity Attorney Marketplace. You set the attorney pledge amount ($300–$600). Credlocity admin reviews and may adjust it before the case goes live.',
    'cro.how.your_earnings': 'Your Earnings',
    'cro.how.earnings_detail': "When an attorney takes your case, you receive the case's pledge fee minus a flat Credlocity convenience fee set by the case-value tier — never a percentage of any settlement. Payouts are processed 15 days after the case is assigned.",
    'cro.how.pledge_negotiation': 'Pledge Negotiation',
    'cro.how.pledge_detail': "If an attorney bids below your desired amount, you'll be notified and can accept or decline. If you decline, the attorney has 8 hours to revise before the case goes back to the open marketplace.",
    'cro.how.close': 'Close',

    // CRO Case Submit
    'cro.submit.title': 'Submit New Case',
    'cro.submit.subtitle': 'Submit a client case to the Credlocity Attorney Marketplace',
    'cro.submit.strength_title': 'Case Strength Indicator',
    'cro.submit.client_info': 'Client Information',
    'cro.submit.client_name': 'Client Name *',
    'cro.submit.client_name_placeholder': 'Full legal name',
    'cro.submit.client_state': 'Client State *',
    'cro.submit.select_state': 'Select state',
    'cro.submit.client_email': 'Client Email',
    'cro.submit.client_email_placeholder': 'client@email.com',
    'cro.submit.client_phone': 'Client Phone',
    'cro.submit.client_phone_placeholder': '(555) 123-4567',
    'cro.submit.dispute_dates_tracking': 'Dispute Dates & Tracking',
    'cro.submit.dispute_dates': 'Dispute Dates Sent *',
    'cro.submit.add_date': 'Add Date',
    'cro.submit.mail_method': 'Mail Method *',
    'cro.submit.regular_mail': 'Regular Mail',
    'cro.submit.certified_mail': 'Certified Mail',
    'cro.submit.credit_bureau': 'Credit Bureau *',
    'cro.submit.select_bureau': 'Select bureau',
    'cro.submit.tracking_numbers': 'Certified Mail Tracking Numbers',
    'cro.submit.tracking_placeholder': 'e.g. 7019 1640 0000 0000 0000',
    'cro.submit.add_tracking': 'Add Tracking Number',
    'cro.submit.violation_info': 'Violation Information',
    'cro.submit.violation_type': 'Violation Type *',
    'cro.submit.select_violation': 'Select violation',
    'cro.submit.violation_count': 'Number of Violations *',
    'cro.submit.bureau_responses': 'Bureau Responses Received',
    'cro.submit.doc_quality': 'Documentation Quality',
    'cro.submit.standard': 'Standard',
    'cro.submit.good': 'Good',
    'cro.submit.excellent': 'Excellent',
    'cro.submit.violation_details': 'Violation Details',
    'cro.submit.violation_details_placeholder': 'Describe the violations in detail...',
    'cro.submit.supporting_docs': 'Supporting Documents',
    'cro.submit.docs_subtitle': 'Upload PDFs of letters sent, credit reports, and other evidence. Max 10MB per file.',
    'cro.submit.choose_file': 'Choose File',
    'cro.submit.uploading': 'Uploading...',
    'cro.submit.class_action': 'Class Action (Optional)',
    'cro.submit.class_action_check': 'This case involves a potential class action',
    'cro.submit.affected_consumers': 'Estimated Number of Affected Consumers',
    'cro.submit.class_action_note': 'Cases with 50+ affected consumers qualify for extended bidding window (21 days)',
    'cro.submit.case_summary': 'Case Summary',
    'cro.submit.case_summary_placeholder': 'Provide a summary of the case for reviewing attorneys...',
    'cro.submit.pledge_amount': 'Desired Pledge Amount',
    'cro.submit.pledge_desc': 'Set the attorney pledge fee for this case ($300–$600). Credlocity admin may adjust this before the case goes live.',
    'cro.submit.pledge_standard': '$300 (standard)',
    'cro.submit.pledge_premium': '$600 (premium)',
    'cro.submit.important': 'Important',
    'cro.submit.important_desc': "Cases are reviewed within 24-48 hours. Once approved, they will be listed in the Attorney Marketplace. On every case an attorney takes, you receive the pledge fee minus a flat Credlocity convenience fee — never a percentage of any settlement. Attorneys will only see case metadata until they pledge — your client's contact information and uploaded documents remain protected.",
    'cro.submit.submitting': 'Submitting...',
    'cro.submit.submit_case': 'Submit Case',
    'cro.submit.success_title': 'Case Submitted!',
    'cro.submit.case_number': 'Case Number:',
    'cro.submit.estimated_value': 'Estimated Value:',
    'cro.submit.case_strength': 'Case Strength:',
    'cro.submit.qualifies_bidding': 'This case qualifies for competitive bidding!',
    'cro.submit.review_note': 'Your case will be reviewed by our team within 24-48 hours.',
    'cro.submit.submit_another': 'Submit Another Case',
    'cro.submit.view_tracker': 'View Case Tracker',

    // CRO Subscription
    'cro.subscription.title': 'Subscription Management',
    'cro.subscription.account_suspended': 'Account Suspended',
    'cro.subscription.suspended_msg': 'Your account has been suspended. Contact support for more information.',
    'cro.subscription.lapsed': 'Subscription Lapsed',
    'cro.subscription.lapsed_msg': 'Your subscription has lapsed. Existing case listings remain active, but you cannot submit new cases until you renew.',
    'cro.subscription.renew': 'Renew Subscription',
    'cro.subscription.plan_title': 'CRO Partnership Plan',
    'cro.subscription.plan_desc': '{monthly}/month via Goat Payments (3.98% blended rate)',
    'cro.subscription.signup_fee': 'One-Time Signup Fee',
    'cro.subscription.paid': 'Paid',
    'cro.subscription.pay_now': 'Pay Now',
    'cro.subscription.monthly_sub': 'Monthly Subscription',
    'cro.subscription.active': 'Active',
    'cro.subscription.inactive': 'Inactive',
    'cro.subscription.started': 'Subscription Started',
    'cro.subscription.next_renewal': 'Next Renewal',
    'cro.subscription.cases_submitted': 'Cases Submitted',
    'cro.subscription.fees_earned': 'Fees Earned',
    'cro.subscription.chargebacks': 'Chargebacks',
    'cro.subscription.subscribe': 'Subscribe',
    'cro.subscription.benefits_title': 'Active Subscription Unlocks:',
    'cro.subscription.benefit_1': 'Unlimited case submissions to the Attorney Marketplace',
    'cro.subscription.benefit_2': 'The pledge fee on every case taken, minus a flat Credlocity convenience fee',
    'cro.subscription.benefit_3': 'Access to the Payout Dashboard with real-time earnings',
    'cro.subscription.benefit_4': 'Case status tracking for all submitted cases',
    'cro.subscription.benefit_5': 'Add supplemental notes or evidence to open cases',
    'cro.subscription.benefit_6': 'View counts on each case listing (how many attorneys viewed)',
    'cro.subscription.secure_payments': 'Secure Payments via Goat Payments',
    'cro.subscription.payment_desc': 'All subscription payments are processed through Goat Payments at a 3.98% blended rate. Your payment information is encrypted and secure.',
    'cro.subscription.pay_signup': 'Pay Signup Fee',
    'cro.subscription.subscribe_monthly': 'Subscribe Monthly',
    'cro.subscription.one_time_fee': 'One-Time Signup Fee',
    'cro.subscription.processing': 'Processing (3.98%)',
    'cro.subscription.total': 'Total',
    'cro.subscription.coupon_discount': 'Coupon Discount',
    'cro.subscription.have_coupon': 'Have a coupon code?',
    'cro.subscription.enter_coupon': 'Enter coupon code',
    'cro.subscription.apply': 'Apply',
    'cro.subscription.free_months': 'free month applied — next billing extended.',
    'cro.subscription.free_months_plural': 'free months applied — next billing extended.',
    'cro.subscription.cardholder_name': 'Cardholder Name',
    'cro.subscription.card_number': 'Card Number',
    'cro.subscription.mm_yy': 'MM/YY',
    'cro.subscription.cvv': 'CVV',
    'cro.subscription.secured_by': 'Secured by Goat Payments | 3.98% blended rate',
    'cro.subscription.processing_payment': 'Processing...',
    'cro.subscription.pay': 'Pay',

    // CRO Case Tracker
    'cro.tracker.title': 'Case Tracker',
    'cro.tracker.total_cases': 'total cases',
    'cro.tracker.refresh': 'Refresh',
    'cro.tracker.search_placeholder': 'Search by name or case number...',
    'cro.tracker.no_cases': 'No cases found',
    'cro.tracker.all_statuses': 'All Statuses',
    'cro.tracker.pending_review': 'Pending Review',
    'cro.tracker.approved': 'Approved',
    'cro.tracker.listed': 'Listed',
    'cro.tracker.pledged': 'Pledged',
    'cro.tracker.bidding': 'Bidding',
    'cro.tracker.awarded': 'Awarded',
    'cro.tracker.completed': 'Completed',
    'cro.tracker.rejected': 'Rejected',
    'cro.tracker.bidding_eligible': 'Bidding Eligible',
    'cro.tracker.class_action': 'Class Action',
    'cro.tracker.state': 'State',
    'cro.tracker.mail_method': 'Mail Method',
    'cro.tracker.violations': 'Violations',
    'cro.tracker.doc_quality': 'Documentation Quality',
    'cro.tracker.dispute_date': 'Dispute Date',
    'cro.tracker.pledge_fee': 'Pledge Fee',
    'cro.tracker.assigned_attorney': 'Assigned Attorney',
    'cro.tracker.winning_bid': 'Winning Bid',
    'cro.tracker.your_payout': 'Your Payout',
    'cro.tracker.case_summary': 'Case Summary',
    'cro.tracker.est': 'Est.',

    // CRO Messages
    'cro.messages.title': 'Messages',
    'cro.messages.conversations': 'Conversations',
    'cro.messages.no_conversations': 'No conversations yet',
    'cro.messages.no_conversations_desc': 'Messages appear when an attorney pledges on your case',
    'cro.messages.select_conversation': 'Select a conversation',
    'cro.messages.select_desc': 'Choose from the list to view messages',
    'cro.messages.type_message': 'Type your message...',
    'cro.messages.attorney': 'Attorney',

    // CRO Payout Dashboard
    'cro.payouts.title': 'Payout Dashboard',
    'cro.payouts.pending_balance': 'Pending Balance',
    'cro.payouts.approved_balance': 'Approved Balance',
    'cro.payouts.lifetime_paid': 'Lifetime Paid',
    'cro.payouts.total_cases': 'Total Cases',
    'cro.payouts.payout_history': 'Payout History',
    'cro.payouts.no_payouts': 'No payouts yet. Submit cases and earn when attorneys pledge or bid.',
    'cro.payouts.case': 'Case',
    'cro.payouts.pledge_fee': 'Pledge Fee',
    'cro.payouts.convenience_fee': 'Convenience Fee',
    'cro.payouts.transaction_fee': 'Transaction Fee',
    'cro.payouts.your_share': 'Your Share',
    'cro.payouts.price_range': 'Your Price',
    'cro.payouts.you_receive': 'You Receive',
    'cro.payouts.share_note': 'Your share = the price you set for the case (your slider amount) minus a flat Credlocity convenience fee and a small transaction fee (a fixed percentage). Never a percentage of any settlement.',
    'cro.payouts.earned': 'Earned',
    'cro.payouts.earliest_payout': 'Earliest Payout',
    'cro.payouts.status': 'Status',
    'cro.payouts.case_views': 'Case Listing Views',
    'cro.payouts.no_cases': 'No cases submitted yet',

    // CRO Earnings
    'cro.earnings.title': 'Earnings Tracker',
    'cro.earnings.subtitle': 'Track your payouts from attorney pledges and bids',
    'cro.earnings.refresh': 'Refresh',
    'cro.earnings.lifetime': 'Lifetime Earnings',
    'cro.earnings.pending': 'Pending Payouts',
    'cro.earnings.total_payouts': 'Total Payouts',
    'cro.earnings.payout_history': 'Payout History',
    'cro.earnings.payout_desc': 'All payouts from attorney pledges and bid awards',
    'cro.earnings.date': 'Date',
    'cro.earnings.case': 'Case',
    'cro.earnings.type': 'Type',
    'cro.earnings.amount': 'Amount',
    'cro.earnings.status': 'Status',
    'cro.earnings.paid': 'Paid',
    'cro.earnings.pending_status': 'Pending',
    'cro.earnings.no_payouts': 'No payouts yet',
    'cro.earnings.no_payouts_desc': 'Submit cases and earn the pledge fee (minus a flat convenience fee) when attorneys take them',
    'cro.earnings.how_title': 'How Earnings Work',
    'cro.earnings.how_1': "When an attorney takes your case, they pay a flat pledge fee set by the case's value tier",
    'cro.earnings.how_2': 'You receive that pledge fee minus a flat Credlocity convenience fee — never a percentage of any settlement',
    'cro.earnings.how_3': 'For bidding cases, the same flat pledge-fee model applies to the case the winning attorney takes',
    'cro.earnings.how_4': 'Payouts are processed 15 days after a case is assigned',

    // CRO Team Management
    'cro.team.title': 'Team Management',
    'cro.team.subtitle': 'Team members can submit cases under your organization.',
    'cro.team.add_member': 'Add Team Member',
    'cro.team.info': "Team members log in at the same CRO Portal URL and can submit cases, track case status, and message attorneys — all under your organization's account.",
    'cro.team.members_title': 'Team Members',
    'cro.team.no_members': 'No Team Members Yet',
    'cro.team.no_members_desc': 'Add team members so they can submit cases under your organization.',
    'cro.team.add_first': 'Add First Member',
    'cro.team.name': 'Name',
    'cro.team.email': 'Email',
    'cro.team.role': 'Role',
    'cro.team.status': 'Status',
    'cro.team.added': 'Added',
    'cro.team.actions': 'Actions',
    'cro.team.add_modal_title': 'Add Team Member',
    'cro.team.full_name': 'Full Name *',
    'cro.team.email_address': 'Email Address *',
    'cro.team.role_label': 'Role *',
    'cro.team.role_member': 'Member — can submit and track cases',
    'cro.team.role_manager': 'Manager — full access',
    'cro.team.welcome_email': 'A welcome email with a temporary password will be sent automatically.',
    'cro.team.adding': 'Adding...',
    'cro.team.add_member_btn': 'Add Member',
    'cro.team.remove_confirm': 'Remove',
    'cro.team.from_team': 'from your team?',

    // CRO Settings
    'cro.settings.title': 'Account Settings',
    'cro.settings.company_info': 'Company Information',
    'cro.settings.company_desc': "Update your organization's details",
    'cro.settings.company_name': 'Company Name',
    'cro.settings.owner_name': 'Owner Name',
    'cro.settings.phone': 'Phone',
    'cro.settings.website': 'Website',
    'cro.settings.license_number': 'License Number',
    'cro.settings.email': 'Email',
    'cro.settings.ein': 'EIN',
    'cro.settings.state': 'State',
    'cro.settings.referral_code': 'Referral Code',
    'cro.settings.change_password': 'Change Password',
    'cro.settings.password_desc': 'Leave blank to keep current password',
    'cro.settings.current_password': 'Current Password',
    'cro.settings.new_password': 'New Password',
    'cro.settings.confirm_password': 'Confirm New Password',
    'cro.settings.saving': 'Saving...',
    'cro.settings.save_changes': 'Save Changes',

    // CRO Change Password
    'cro.changepass.set_title': 'Set Your Password',
    'cro.changepass.change_title': 'Change Password',
    'cro.changepass.set_desc': 'Please create a new password before continuing to your portal.',
    'cro.changepass.change_desc': 'Update your CRO portal password.',
    'cro.changepass.current_password': 'Current Password',
    'cro.changepass.new_password': 'New Password',
    'cro.changepass.new_password_placeholder': 'Minimum 8 characters',
    'cro.changepass.confirm_password': 'Confirm New Password',
    'cro.changepass.confirm_placeholder': 'Re-enter new password',
    'cro.changepass.saving': 'Saving...',
    'cro.changepass.set_new': 'Set New Password',
    'cro.changepass.success': 'Password changed successfully. Redirecting...',
    'cro.changepass.min_chars': 'Password must be at least 8 characters',
    'cro.changepass.no_match': 'Passwords do not match',
    'cro.changepass.failed': 'Failed to change password',
    'cro.changepass.connect_failed': 'Failed to connect to server',

    // CRO Landing Page
    'cro.landing.badge': 'CRO Partnership Program',
    'cro.landing.hero_title': 'Turn Your Credit Repair Cases Into Revenue',
    'cro.landing.hero_desc': 'Submit your FCRA, FDCPA, and TCPA violation cases to our Attorney Marketplace. When attorneys take your cases, you earn the pledge fee minus a flat convenience fee — automatically.',
    'cro.landing.apply_now': 'Apply Now',
    'cro.landing.partner_login': 'Partner Login',
    'cro.landing.revenue_share': "Credlocity's cut (never a % of settlement)",
    'cro.landing.pledge_fee': 'Per-case pledge fee',
    'cro.landing.payout_timeline': 'Payout Timeline',
    'cro.landing.monthly_fee': 'Monthly Fee',
    'cro.landing.how_works_title': 'How the CRO Partnership Works',
    'cro.landing.how_works_desc': 'A simple, transparent process from case submission to payout',
    'cro.landing.step': 'STEP',
    'cro.landing.step1_title': 'Submit Cases',
    'cro.landing.step1_desc': 'Upload your consumer dispute cases with supporting documentation to our marketplace.',
    'cro.landing.step2_title': 'Case Review',
    'cro.landing.step2_desc': 'Our team reviews and values your case within 24-48 hours, then lists it for attorneys.',
    'cro.landing.step3_title': 'Attorney Action',
    'cro.landing.step3_desc': 'Attorneys pledge on or bid for your case, paying the platform directly.',
    'cro.landing.step4_title': 'Get Paid',
    'cro.landing.step4_desc': "You automatically receive the case's pledge fee, minus a flat Credlocity convenience fee, 15 days after the case is assigned.",
    'cro.landing.valuation_title': 'Case Valuation System',
    'cro.landing.valuation_desc': 'Cases are valued based on multiple factors that determine their worth to attorneys',
    'cro.landing.val1_title': 'Violation Count',
    'cro.landing.val1_desc': 'Base value of $1,000 per violation. More violations = higher case value.',
    'cro.landing.val2_title': 'Mail Method',
    'cro.landing.val2_desc': 'Certified mail cases receive a 1.5x multiplier over regular mail.',
    'cro.landing.val3_title': 'Documentation Quality',
    'cro.landing.val3_desc': 'Excellent documentation adds a 1.3x multiplier; good adds 1.1x.',
    'cro.landing.val4_title': 'Bureau Responses',
    'cro.landing.val4_desc': 'Each bureau response received adds $500 to the case value.',
    'cro.landing.pledge_vs_bid': 'Pledge vs. Competitive Bidding',
    'cro.landing.standard_pledge': 'Standard Pledge',
    'cro.landing.for_standard': 'For standard-value cases',
    'cro.landing.pledge_b1': "Flat pledge fee set by the case's value tier",
    'cro.landing.pledge_b2': 'You receive the pledge fee minus a flat convenience fee',
    'cro.landing.pledge_b3': 'Immediate attorney assignment',
    'cro.landing.pledge_b4': 'Direct messaging opens instantly',
    'cro.landing.comp_bidding': 'Competitive Bidding',
    'cro.landing.for_highval': 'For high-value cases ($10K+ est. value)',
    'cro.landing.bid_b1': 'Multiple attorneys compete with bids',
    'cro.landing.bid_b2': 'You receive the pledge fee on the winning bid, minus a flat convenience fee',
    'cro.landing.bid_b3': '14-day bidding window (21 for class action)',
    'cro.landing.bid_b4': 'Higher potential earnings per case',
    'cro.landing.class_action_title': 'Class Action Cases',
    'cro.landing.class_action_desc': 'Cases involving 50 or more affected consumers qualify for class action status, receiving extended 21-day bidding windows and enhanced visibility in the marketplace. Class action cases often generate significantly higher bids from attorneys.',
    'cro.landing.requirements_title': 'Partnership Requirements',
    'cro.landing.req_1': 'Legally registered Credit Repair Organization',
    'cro.landing.req_2': 'Valid Employer Identification Number (EIN)',
    'cro.landing.req_3': 'Compliance with CROA and all applicable laws',
    'cro.landing.req_4': 'Professional liability insurance',
    'cro.landing.req_5': 'No pending regulatory actions',
    'cro.landing.req_6': 'Accurate and complete case documentation',
    'cro.landing.req_7': '{signup} one-time signup fee',
    'cro.landing.req_8': '{monthly} monthly subscription',
    'cro.landing.enforcement_title': 'Enforcement Policy',
    'cro.landing.enforcement_desc': 'We maintain a strict enforcement policy to protect consumers and attorneys',
    'cro.landing.first_strike': 'First Strike',
    'cro.landing.first_strike_desc': 'Written warning with details of the violation',
    'cro.landing.second_strike': 'Second Strike',
    'cro.landing.second_strike_desc': '30-day suspension from the platform',
    'cro.landing.third_strike': 'Third Strike',
    'cro.landing.third_strike_desc': 'Permanent removal from the CRO Partnership Program',
    'cro.landing.cta_title': 'Ready to Partner with Credlocity?',
    'cro.landing.cta_desc': 'Join our network and start earning from your credit repair cases today.',
    'cro.landing.start_registration': 'Start Registration',
    'cro.landing.registration_title': 'CRO Partnership Registration',
    'cro.landing.participation_agreement': 'Participation Agreement',
    'cro.landing.scroll_to_accept': 'Please scroll through the entire agreement to accept',
    'cro.landing.i_agree': 'I have read and agree to the Participation Agreement',
    'cro.landing.ip_notice': 'By submitting this registration, your IP address will be recorded alongside your agreement acceptance for legal compliance and verification purposes.',
    'cro.landing.company_info': 'Company Information',
    'cro.landing.company_name': 'Company Name *',
    'cro.landing.company_placeholder': 'Your CRO company name',
    'cro.landing.owner_name': 'Owner / Principal Name *',
    'cro.landing.owner_placeholder': 'Full legal name',
    'cro.landing.email': 'Email *',
    'cro.landing.email_placeholder': 'business@company.com',
    'cro.landing.phone': 'Phone *',
    'cro.landing.phone_placeholder': '(555) 123-4567',
    'cro.landing.ein': 'EIN (Employer Identification Number) *',
    'cro.landing.ein_placeholder': 'XX-XXXXXXX',
    'cro.landing.state': 'State *',
    'cro.landing.select_state': 'Select state',
    'cro.landing.license': 'License Number',
    'cro.landing.license_placeholder': 'Optional',
    'cro.landing.website': 'Website',
    'cro.landing.website_placeholder': 'https://',
    'cro.landing.create_password': 'Create Password',
    'cro.landing.password': 'Password *',
    'cro.landing.password_placeholder': 'Min. 8 characters',
    'cro.landing.confirm_password': 'Confirm Password *',
    'cro.landing.confirm_placeholder': 'Re-enter password',
    'cro.landing.reg_fees': 'Registration Fees',
    'cro.landing.one_time_fee': 'One-Time Signup Fee',
    'cro.landing.monthly_sub': 'Monthly Subscription',
    'cro.landing.free_trial_included': '-day free trial included!',
    'cro.landing.payment_note': 'Payment will be processed upon submission.',
    'cro.landing.promo_code': 'Promo Code (Optional)',
    'cro.landing.promo_placeholder': 'Enter promo code',
    'cro.landing.checking': 'Checking...',
    'cro.landing.payment_info': 'Payment Information',
    'cro.landing.card_number': 'Card Number *',
    'cro.landing.expiration': 'Expiration (MMYY) *',
    'cro.landing.cvv': 'CVV *',
    'cro.landing.submitting': 'Submitting...',
    'cro.landing.submit_application': 'Submit Application',
    'cro.landing.already_partner': 'Already a partner?',
    'cro.landing.sign_in': 'Sign in here',
    'cro.landing.back_home': 'Back to Credlocity Home',

    // CRO — newly added (full translation pass)
    'cro.dashboard.failed_load': 'Failed to load dashboard',
    'cro.dashboard.connect_failed': 'Failed to connect to server',
    'cro.submit.doc_collection_agency': 'Letter to Collection Agency',
    'cro.submit.doc_credit_bureau': 'Letter to Credit Bureau',
    'cro.submit.doc_original_creditor': 'Letter to Original Creditor',
    'cro.submit.doc_credit_report': 'Credit Report (Before/After)',
    'cro.submit.doc_other': 'Other Supporting Document',
    'cro.submit.factor_certified': 'Certified mail used',
    'cro.submit.factor_tracking': 'tracking number(s)',
    'cro.submit.factor_docs': 'document(s) uploaded',
    'cro.submit.factor_violations': 'violation(s)',
    'cro.submit.factor_responses': 'bureau response(s)',
    'cro.submit.factor_dates': 'dispute date(s)',
    'cro.submit.strength_strong': 'Strong',
    'cro.submit.strength_moderate': 'Moderate',
    'cro.submit.strength_fair': 'Fair',
    'cro.submit.strength_weak': 'Weak',
    'cro.submit.toast_file_too_large': 'File too large. Max 10MB.',
    'cro.submit.toast_file_type': 'File type not allowed:',
    'cro.submit.toast_uploaded': 'Uploaded:',
    'cro.submit.toast_upload_failed': 'Upload failed',
    'cro.submit.toast_upload_error': 'Failed to upload file',
    'cro.submit.toast_date_required': 'At least one dispute date is required',
    'cro.submit.toast_success': 'Case submitted successfully!',
    'cro.submit.toast_submit_failed': 'Failed to submit case',
    'cro.submit.toast_connect_failed': 'Failed to connect to server',
    'cro.subscription.toast_load_failed': 'Failed to load subscription info',
    'cro.subscription.toast_coupon_applied': 'Coupon applied!',
    'cro.subscription.toast_coupon_failed': 'Failed to validate coupon',
    'cro.subscription.invalid_coupon': 'Invalid coupon',
    'cro.subscription.toast_card_required': 'Please fill in all card details',
    'cro.subscription.toast_payment_failed': 'Payment failed',
    'cro.subscription.toast_payment_error': 'Payment processing failed',
    'cro.subscription.per_month': '/month',
    'cro.subscription.processing_label': 'processing',
    'cro.subscription.free_months_short': 'free month applied',
    'cro.subscription.free_months_short_plural': 'free months applied',
    'cro.subscription.discount_applied': 'discount applied',
    'cro.tracker.toast_load_failed': 'Failed to load cases',
    'cro.messages.toast_load_failed': 'Failed to load messages',
    'cro.messages.toast_send_failed': 'Failed to send',
    'cro.messages.toast_send_error': 'Failed to send message',
    'cro.payouts.toast_load_failed': 'Failed to load payout dashboard',
    'cro.earnings.toast_load_failed': 'Failed to load earnings',
    'cro.team.toast_load_failed': 'Failed to load team members',
    'cro.team.toast_connect_failed': 'Failed to connect to server',
    'cro.team.toast_added': 'Team member added — welcome email sent',
    'cro.team.toast_add_failed': 'Failed to add team member',
    'cro.team.toast_removed': 'Team member removed',
    'cro.team.toast_remove_failed': 'Failed to remove team member',
    'cro.team.email_placeholder': 'jane@example.com',
    'cro.settings.toast_load_failed': 'Failed to load profile',
    'cro.settings.toast_no_match': 'Passwords do not match',
    'cro.settings.toast_updated': 'Profile updated',
    'cro.settings.toast_update_failed': 'Failed to update',
    'cro.settings.toast_save_failed': 'Failed to save changes',
    'cro.login.invalid_credentials': 'Invalid credentials',
    'cro.login.connect_failed': 'Failed to connect to server',
    'cro.login.email_placeholder': 'cro@company.com',
    'cro.login.password_placeholder': 'Enter password',
    'cro.landing.free': 'FREE',
    'cro.landing.per_mo': '/mo',
    'cro.landing.toast_promo_applied': 'Promo code applied!',
    'cro.landing.toast_invalid_promo': 'Invalid promo code',
    'cro.landing.toast_promo_failed': 'Failed to validate code',
    'cro.landing.toast_accept_agreement': 'You must accept the participation agreement',
    'cro.landing.toast_no_match': 'Passwords do not match',
    'cro.landing.toast_min_chars': 'Password must be at least 8 characters',
    'cro.landing.toast_payment_required': 'Payment information is required',
    'cro.landing.toast_reg_failed': 'Registration failed',
    'cro.landing.toast_payment_failed': 'Payment failed — your registration was saved, please contact support.',
    'cro.landing.toast_reg_success': 'Registration submitted! Your application will be reviewed within 24-48 hours.',
    'cro.landing.toast_connect_failed': 'Failed to connect to server',

    // CRO Messages Hub
    'cro.hub.support_tab': 'Credlocity Support',
    'cro.hub.attorney_tab': 'Attorney conversations',

    // Attorney login
    'attorney.portal_title': 'Attorney Portal',
    'attorney.portal_subtitle': 'Sign in to access your cases and the marketplace',
    'attorney.not_registered': 'Not registered yet?',
    'attorney.apply_network': 'Apply to join our network',
    'attorney.forgot_desc': "Enter your attorney email address and we'll send a temporary password.",

    // CRO Dashboard — new tile + greeting keys (Part 1 & 3)
    'cro.dash.greeting_eyebrow': 'Welcome back',
    'cro.dash.greeting': 'Hi, {name}',
    'cro.dash.hero_summary': '{pending} on the Market Place · {pledged} pledged',
    'cro.dash.submit_cta': 'Submit a case',
    'cro.dash.pending_title': 'Pending on the Market Place',
    'cro.dash.pending_cap': 'Live or awaiting review',
    'cro.dash.pledged_title': 'Pledged',
    'cro.dash.pledged_cap': 'An attorney has taken these',
    'cro.dash.earned_title': 'Earned for you',
    'cro.dash.paid': 'Paid',
    'cro.dash.pending_label': 'Pending',
    'cro.dash.recovered_title': 'Recovered for your clients',
    'cro.dash.recovered_cap': 'From attorney-reported results',
    'cro.dash.views_title': 'Case views',

    // CRO nav group headers (Part 2)
    'cro.navgroup.cases': 'Cases',
    'cro.navgroup.money': 'Money',
    'cro.navgroup.communication': 'Communication',
    'cro.navgroup.account': 'Account',

    // CRO nav item labels not previously keyed
    'cro.nav.billing': 'Billing',
    'cro.nav.book_call': 'Book a Call',
    'cro.nav.add_documents': 'Add Documents',

    // CRO Social Proof — nav + dashboard strip (cro.sp.*)
    'cro.sp.nav': 'Social Proof',
    'cro.sp.page_title': 'Social Proof Cards',
    'cro.sp.page_desc': 'Download branded cards for cases where an attorney has accepted or won.',
    'cro.sp.recent_wins_title': 'Recent Wins',
    'cro.sp.view_all': 'View all',
    'cro.sp.new_win_banner': 'New win — your Social Proof card is ready',
    'cro.sp.badge_won': 'Case Won',
    'cro.sp.badge_accepted': 'Case Accepted',
    'cro.sp.potential': 'potential',
    'cro.sp.no_cards': 'No social proof cards yet',
    'cro.sp.no_cards_desc': 'Cards appear when an attorney accepts or wins one of your cases.',
    'cro.sp.sample_title': "Here's what your cards will look like",
    'cro.sp.sample_desc': 'Your real cards appear here as soon as an attorney takes one of your cases. These are samples in your branding.',
    'cro.sp.load_error': 'Failed to load social proof cards',
    'cro.sp.size_square': 'Square (1080×1080)',
    'cro.sp.size_tall': 'Tall (1080×1920)',
    'cro.sp.download': 'Download PNG',
    'cro.sp.consent_label': 'My customer agreed to be featured on social media',
    'cro.sp.consent_confirm': 'Confirm & Enable Download',
    'cro.sp.consent_saving': 'Saving...',
    'cro.sp.cors_warn': "Logo could not be embedded due to a cross-origin restriction. Switch watermark to 'Company Name' and retry.",
    'cro.sp.wm_title': 'Watermark Settings',
    'cro.sp.wm_type_label': 'Watermark type',
    'cro.sp.wm_logo': 'Logo',
    'cro.sp.wm_name': 'Company Name',
    'cro.sp.wm_strength_label': 'Strength',
    'cro.sp.wm_none': 'None',
    'cro.sp.wm_strong': 'Strong',
    'cro.sp.tracker_btn': 'Social Proof',

    // Company pickers + violation questions (CompanyPicker.js, ViolationQuestions.js)
    'amp.company_picker.collector_label': 'Collector / Defendant Company',
    'amp.company_picker.bureau_label': 'Credit Bureau',
    'amp.company_picker.select_placeholder': '— Select —',
    'amp.violation_questions.label': 'Specific Violation Details (check all that apply)',
    'amp.violation_questions.loading': 'Loading violation questions…',
    'amp.violation_questions.fcra_heading': 'FCRA Violations',
    'amp.violation_questions.fdcpa_heading': 'FDCPA Violations',
  },
  es: {
    // CMS Navigation
    'nav.dashboard': 'Panel Principal',
    'nav.analytics': 'Analiticas',
    'nav.operations': 'Operaciones',
    'nav.collections': 'Cobranzas',
    'nav.collections_dashboard': 'Panel',
    'nav.accounts': 'Cuentas',
    'nav.new_account': 'Nueva Cuenta',
    'nav.approvals': 'Aprobaciones',
    'nav.commissions': 'Comisiones',
    'nav.commission_config': 'Config. Comisiones',
    'nav.voice_settings': 'Config. de Voz',
    'nav.disputes': 'Disputas',
    'nav.clients': 'Clientes',
    'nav.all_clients': 'Todos los Clientes',
    'nav.outsourcing': 'Subcontratacion',
    'nav.outsourcing_dashboard': 'Panel',
    'nav.inquiries': 'Consultas',
    'nav.partners_list': 'Socios',
    'nav.escalations': 'Escalaciones',
    'nav.work_logs': 'Registro de Trabajo',
    'nav.invoices': 'Facturas',
    'nav.legal': 'Legal',
    'nav.attorney_marketplace': 'Mercado de Abogados',
    'nav.case_management': 'Gestion de Casos',
    'nav.submit_case': 'Enviar Caso',
    'nav.attorney_network': 'Red de Abogados',
    'nav.penalties': 'Penalidades',
    'nav.revenue_splits': 'Division de Ingresos',
    'nav.lawsuits_filed': 'Demandas Presentadas',
    'nav.marketing': 'Marketing',
    'nav.website': 'Sitio Web',
    'nav.pages': 'Paginas',
    'nav.blog': 'Blog',
    'nav.faqs': 'Preguntas Frecuentes',
    'nav.press_releases': 'Comunicados de Prensa',
    'nav.legal_pages': 'Paginas Legales',
    'nav.banners_popups': 'Banners y Ventanas',
    'nav.media_library': 'Biblioteca de Medios',
    'nav.education_hub': 'Centro Educativo',
    'nav.reviews_social': 'Resenas y Prueba Social',
    'nav.reviews': 'Resenas',
    'nav.outsource_reviews': 'Resenas de Socios',
    'nav.categories': 'Categorias',
    'nav.hr_payroll': 'RRHH y Nomina',
    'nav.team_management': 'Gestion de Equipo',
    'nav.authors_profiles': 'Autores / Perfiles',
    'nav.payroll': 'Nomina',
    'nav.training': 'Capacitacion',
    'nav.security': 'Seguridad',
    'nav.finance': 'Finanzas',
    'nav.billing': 'Facturacion',
    'nav.partners': 'Socios',
    'nav.affiliates_partners': 'Afiliados y Socios',
    'nav.tools': 'Herramientas',
    'nav.chat_support': 'Chat y Soporte',
    'nav.team_chat': 'Chat del Equipo',
    'nav.customer_support': 'Soporte al Cliente',
    'nav.document_center': 'Centro de Documentos',
    'nav.admin': 'Administracion',
    'nav.access_control': 'Control de Acceso',
    'nav.site_settings': 'Configuracion del Sitio',
    'nav.marketplace_mgmt': 'Gestion del Mercado',
    'nav.view_site': 'Ver Sitio',
    'nav.affiliate_leads': 'Prospectos de Afiliados',
    'nav.comparisons': 'Comparaciones',
    'nav.credlocity_partners': 'Socios de Credlocity',
    'nav.add_partner': 'Agregar Socio',
    'nav.forms_calendars': 'Formularios y Calendarios',
    'nav.intake_forms': 'Formularios de Ingreso',
    'nav.calendars': 'Calendarios',
    'nav.settings': 'Configuracion',
    'nav.lawsuit_config': 'Config. Demandas',
    'nav.complaints': 'Quejas',
    'nav.outsource_reviews': 'Resenas de Socios',
    'nav.welcome': 'Bienvenido a Credlocity CMS',
    'nav.welcome_sub': 'Administre su contenido, socios y operaciones comerciales',
    'nav.quick_actions': 'Acciones Rapidas',
    'nav.new_blog_post': 'Nueva Publicacion',
    'nav.add_lawsuit': 'Agregar Demanda',
    'nav.manage_partners': 'Gestionar Socios',
    'nav.add_review': 'Agregar Resena',

    // Dashboard KPIs
    'kpi.content_overview': 'Resumen de Contenido',
    'kpi.collections_revenue': 'Cobranzas e Ingresos',
    'kpi.hr_payroll': 'RRHH y Nomina',
    'nav.lawsuits_filed': 'Demandas Presentadas',
    'nav.marketing': 'Marketing',
    'nav.website': 'Sitio Web',
    'nav.reviews_social': 'Resenas y Prueba Social',
    'nav.hr_payroll': 'RRHH y Nomina',
    'nav.team_management': 'Gestion de Equipo',
    'nav.authors_profiles': 'Autores / Perfiles',
    'nav.payroll': 'Nomina',
    'nav.training': 'Capacitacion',
    'nav.security': 'Seguridad',
    'nav.finance': 'Finanzas',
    'nav.billing': 'Facturacion',
    'nav.partners': 'Socios',
    'nav.affiliates_partners': 'Afiliados y Socios',
    'nav.tools': 'Herramientas',
    'nav.chat_support': 'Chat y Soporte',
    'nav.team_chat': 'Chat del Equipo',
    'nav.customer_support': 'Soporte al Cliente',
    'nav.document_center': 'Centro de Documentos',
    'nav.admin': 'Administracion',
    'nav.access_control': 'Control de Acceso',
    'nav.site_settings': 'Configuracion del Sitio',
    'nav.marketplace_mgmt': 'Gestion del Mercado',
    'nav.view_site': 'Ver Sitio',

    // Dashboard KPIs
    'kpi.total_content': 'Contenido Total',
    'kpi.blog_posts': 'Publicaciones',
    'kpi.pages': 'Paginas',
    'kpi.faqs': 'Preguntas Frecuentes',
    'kpi.media': 'Archivos Multimedia',
    'kpi.team_members': 'Miembros del Equipo',
    'kpi.reviews': 'Resenas',
    'kpi.active_accounts': 'Cuentas Activas',
    'kpi.total_owed': 'Total Adeudado',
    'kpi.commissions_earned': 'Comisiones Ganadas',
    'kpi.pending_commissions': 'Comisiones Pendientes',
    'kpi.employees': 'Empleados',
    'kpi.annual_salaries': 'Salarios Anuales',
    'kpi.monthly_commissions': 'Comisiones Mensuales',
    'kpi.bonuses': 'Bonificaciones',
    'kpi.active_lawsuits': 'Demandas Activas',
    'kpi.marketplace_cases': 'Casos en Mercado',
    'kpi.attorney_network': 'Red de Abogados',
    'kpi.total_clients': 'Total de Clientes',
    'kpi.active_cases': 'Casos Activos',
    'kpi.recent_submissions': 'Envios Recientes',

    // Dashboard Home
    'dashboard.recent_posts': 'Publicaciones Recientes',
    'dashboard.view_all': 'Ver Todo',
    'dashboard.system_status': 'Estado del Sistema',
    'dashboard.quick_links': 'Enlaces Rapidos',
    'dashboard.no_posts': 'No hay publicaciones aun',
    'dashboard.create_first': 'Crea tu primera publicacion',
    'dashboard.legal_content': 'Contenido Legal',
    'dashboard.outsourcing': 'Subcontratacion',
    'dashboard.clients': 'Clientes',
    'dashboard.active_partners': 'Socios Activos',
    'dashboard.pending_inquiries': 'Consultas Pendientes',
    'dashboard.open_tickets': 'Tickets Abiertos',
    'dashboard.commission_earned': 'Comisiones Ganadas',
    'dashboard.active_trackers': 'Rastreadores Activos',
    'dashboard.active_employees': 'Empleados Activos',
    'dashboard.training_modules': 'Modulos de Capacitacion',
    'dashboard.lawsuits_filed': 'Demandas Presentadas',
    'dashboard.press_releases': 'Comunicados de Prensa',
    'dashboard.hot_leads': 'Prospectos Calientes',
    'dashboard.new_30_days': 'Nuevos (30 dias)',
    'dashboard.website': 'Sitio Web',
    'dashboard.online': 'En Linea',
    'dashboard.api': 'API',
    'dashboard.operational': 'Operacional',
    'dashboard.database': 'Base de Datos',
    'dashboard.connected': 'Conectada',
    'dashboard.media_library': 'Biblioteca de Medios',
    'dashboard.site_settings': 'Configuracion del Sitio',
    'dashboard.needs_attention': 'Necesita atencion',
    'dashboard.all_caught_up': 'Todo al dia!',
    'dashboard.escalations': 'Escalaciones',
    'dashboard.no_open_tickets': 'Sin tickets abiertos',
    'dashboard.ready_to_convert': 'Listo para convertir',
    'dashboard.no_hot_leads': 'Sin prospectos calientes',
    'dashboard.dashboard': 'Panel',
    'dashboard.view': 'Ver',
    'dashboard.collections': 'Cobranzas',
    'dashboard.threshold_tracking': 'Seguimiento de umbral 70%',

    // Common UI
    'common.search': 'Buscar',
    'common.filter': 'Filtrar',
    'common.add': 'Agregar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.submit': 'Enviar',
    'common.refresh': 'Actualizar',
    'common.loading': 'Cargando...',
    'common.no_results': 'No se encontraron resultados',
    'common.actions': 'Acciones',
    'common.status': 'Estado',
    'common.active': 'Activo',
    'common.inactive': 'Inactivo',
    'common.all': 'Todos',
    'common.name': 'Nombre',
    'common.email': 'Correo',
    'common.phone': 'Telefono',
    'common.department': 'Departamento',
    'common.role': 'Rol',
    'common.type': 'Tipo',
    'common.date': 'Fecha',
    'common.back': 'Volver',
    'common.view': 'Ver',
    'common.download': 'Descargar',
    'common.upload': 'Subir',
    'common.close': 'Cerrar',
    'common.confirm': 'Confirmar',
    'common.yes': 'Si',
    'common.no': 'No',
    'common.apply': 'Aplicar',

    // Employee Directory
    'team.title': 'Directorio de Empleados',
    'team.subtitle': 'Administre los miembros del equipo, roles y departamentos',
    'team.add_employee': 'Agregar Empleado',
    'team.total_members': 'Total de Miembros',
    'team.employees': 'Empleados',
    'team.contractors': 'Contratistas',
    'team.departments': 'Departamentos',
    'team.search_placeholder': 'Buscar por nombre o correo...',
    'team.all_roles': 'Todos los Roles',
    'team.all_types': 'Todos los Tipos',
    'team.back_to_directory': 'Volver al Directorio',
    'team.org_chart': 'Organigrama',
    'team.contact': 'Contacto',
    'team.employment': 'Empleo',
    'team.training_progress': 'Progreso de Capacitacion',
    'team.emergency_contact': 'Contacto de Emergencia',
    'team.skills': 'Habilidades y Experiencia',
    'team.about': 'Acerca de',
    'team.admin_notes': 'Notas del Administrador',
    'team.hire_date': 'Fecha de Contratacion',
    'team.birthday': 'Cumpleanos',
    'team.tenure': 'Antiguedad',
    'team.full_name': 'Nombre Completo',
    'team.job_title': 'Titulo del Puesto',
    'team.location': 'Ubicacion',
    'team.bio': 'Biografia',
    'team.linkedin': 'URL de LinkedIn',
    'team.profile_photo': 'Foto de Perfil',
    'team.password': 'Contrasena',

    // Homepage
    'home.hero_title': 'REPARACION DE CREDITO HECHA BIEN',
    'home.hero_subtitle': 'Elimine Elementos Negativos, Cobros y Pagos Atrasados de Su Reporte de Credito',
    'home.hero_desc': 'Servicios profesionales de reparacion de credito que le ayudan a mejorar su puntaje crediticio y lograr libertad financiera. Sirviendo a clientes en todo el pais desde 2008.',
    'home.start_free_trial': 'Inicie Su Prueba Gratis de 30 Dias',
    'home.book_consultation': 'Reserve una Consulta Gratis',
    'home.day_free_trial': 'Dias de Prueba Gratis',
    'home.longest_industry': 'La Mas Larga en la Industria',
    'home.first_work_fee': 'Sin Cargo Inicial',
    'home.no_upfront': 'Sin Costos Por Adelantado',
    'home.how_title': 'Como Reparar Su Credito: El Proceso Completo',
    'home.how_desc': 'Mas de 79,000 estadounidenses han mejorado sus puntajes de credito usando estrategias probadas de reparacion de credito. Ya sea que repare su credito usted mismo o trabaje con profesionales, entender el proceso es esencial. Aqui tiene todo lo que necesita saber sobre la eliminacion legal de elementos negativos, mejorar su puntaje de credito y lograr la libertad financiera.',
    'home.step1_title': 'Paso 1: Obtenga Sus Reportes de Credito',
    'home.step1_desc': 'Obtenga copias gratuitas de AnnualCreditReport.com o a traves de Experian, Equifax y TransUnion. Revise los tres reportes cuidadosamente buscando errores, informacion desactualizada y elementos negativos inexactos.',
    'home.step2_title': 'Paso 2: Identifique Elementos Disputables',
    'home.step2_desc': 'Busque:',
    'home.step2_b1': 'Cuentas que no reconoce',
    'home.step2_b2': 'Fechas incorrectas de pagos atrasados',
    'home.step2_b3': 'Cobros mas alla del periodo de reporte de 7 anos',
    'home.step2_b4': 'Cuentas duplicadas',
    'home.step2_b5': 'Saldos o limites de credito incorrectos',
    'home.step2_b6': 'Elementos de robo de identidad',
    'home.step3_title': 'Paso 3: Presente Disputas Bajo FCRA',
    'home.step3_desc': 'La Ley de Informes de Credito Justos (FCRA) le da el derecho de disputar cualquier informacion inexacta, incompleta o inverificable. Las agencias de credito deben investigar dentro de 30 dias.',
    'home.step4_title': 'Paso 4: Desafie Elementos No Verificados',
    'home.step4_desc': 'Si los acreedores no pueden verificar la informacion disputada, la agencia de credito debe eliminarla. Las empresas profesionales de reparacion de credito usan estrategias avanzadas incluyendo verificaciones de cumplimiento Metro2 e identificacion de violaciones FCRA.',
    'home.step5_title': 'Paso 5: Monitoree el Progreso',
    'home.step5_desc': 'Rastree los cambios en su puntaje de credito mensualmente. La mayoria de las personas ven mejoras dentro de 60-90 dias de iniciar el proceso de disputa.',
    'home.professional_title': 'Cuando Considerar Reparacion de Credito Profesional',
    'home.professional_desc': 'Aunque puede reparar su credito usted mismo, los servicios profesionales ahorran tiempo y a menudo logran mejores resultados a traves de:',
    'home.pro_b1': 'Estrategias avanzadas de disputa que no puede acceder como consumidor',
    'home.pro_b2': 'Experiencia legal en violaciones de FCRA, FDCPA y FCBA',
    'home.pro_b3': 'Negociaciones con acreedores y acuerdos de pago por eliminacion',
    'home.pro_b4': 'Desafios a las agencias usando problemas tecnicos de cumplimiento Metro2',
    'home.pro_b5': 'Soporte de litigio por violaciones de FCRA',
    'home.get_professional_help': 'Obtenga Ayuda Profesional',
    'home.why_title': 'Por Que Elegir Credlocity Sobre Otras Empresas de Reparacion de Credito',
    'home.why_desc': 'No todas las empresas de reparacion de credito son iguales. Esto es lo que nos hace diferentes de Lexington Law, Credit Saint, The Credit People y otros competidores.',
    'home.feat_ai_title': 'Tecnologia de IA Avanzada',
    'home.feat_ai_desc': 'Nuestra IA propietaria analiza sus reportes de credito usando estandares de cumplimiento Metro2 y crea estrategias de disputa personalizadas apuntando a violaciones de FCRA, FDCPA y FCBA para maxima efectividad.',
    'home.feat_tsr_title': 'Proceso Compatible con TSR',
    'home.feat_tsr_desc': '100% compatible con regulaciones federales. Sin inscripcion por telefono, solo plataforma en linea segura.',
    'home.feat_hispanic_title': 'Empresa de Propiedad Hispana',
    'home.feat_hispanic_desc': 'Fundada por el CEO Joeziel Vazquez en Filadelfia, sirviendo a comunidades diversas en los 50 estados.',
    'home.feat_proven_title': 'Historial Comprobado',
    'home.feat_proven_desc': '16+ anos de experiencia, mas de 79,000 clientes atendidos y miles de historias de exito.',
    'home.feat_certified_title': 'Expertos de Credito Certificados',
    'home.feat_certified_desc': 'Consultor de Credito Certificado (BCCC), Consultor de Puntaje Certificado (CCSC) y profesionales Certificados FCRA con 16+ anos de experiencia.',
    'home.compare': 'Comparenos con competidores:',
    'home.years_exp': 'Anos de Experiencia',
    'home.users': 'Usuarios',
    'home.deleted_debt': 'Deuda Eliminada',
    'home.trial_title': 'Prueba Gratis de 30 Dias',
    'home.trial_desc': 'Experimente nuestro servicio sin riesgo con nuestro paquete de garantia integral',
    'home.trial_b1': '$0 al dia - comience inmediatamente',
    'home.trial_b2': 'Garantia de devolucion de dinero de 180 dias',
    'home.trial_b3': 'Cancele en cualquier momento, sin contratos a largo plazo',
    'home.trial_b4': 'App de Rastreo de Credito incluida gratis',
    'home.trial_disclaimer': '*Pagara por su reporte de credito ($49.95) una vez que conozca a su agente de reparacion asignado. Se requiere informacion de tarjeta de credito pero no se cobra la tarifa de servicio por 30 dias.',
    'home.start_trial': 'Inicie Su Prueba Gratis',
    'home.required_services': 'Servicios Requeridos',
    'home.credit_analysis': 'Analisis de Reporte de Credito',
    'home.analysis_b1': 'Revision integral de los tres reportes de credito',
    'home.analysis_b2': 'Revision completa de Experian, Equifax y TransUnion',
    'home.analysis_b3': 'Identificacion de todos los elementos negativos',
    'home.analysis_b4': 'Plan de accion personalizado',
    'home.poa_title': 'Poder Notarial (E-Notario)',
    'home.poa_b1': 'Notarizacion electronica incluida',
    'home.poa_b2': 'Autoridad legal para disputar en su nombre',
    'home.poa_b3': 'Requerido para comunicaciones con las agencias',
    'home.issues_title': 'Problemas de Credito que Solucionamos',
    'home.issues_desc': 'Estrategias expertas de eliminacion para cada tipo de elemento negativo que afecta su puntaje de credito.',
    'home.issue_collection': 'Eliminacion de Cobros',
    'home.issue_collection_desc': 'Elimine cuentas de cobro usando violaciones de FDCPA, disputas de validacion y negociaciones de pago por eliminacion. Los cobros pueden reducir su puntaje 50-100 puntos—los eliminamos permanentemente.',
    'home.issue_late': 'Eliminacion de Pagos Atrasados',
    'home.issue_late_desc': 'Elimine pagos atrasados mediante cartas de buena voluntad, disputas FCBA y desafios de cumplimiento Metro2. Incluso un atraso de 30 dias puede costarle 60-110 puntos.',
    'home.issue_chargeoff': 'Eliminacion de Cargos',
    'home.issue_chargeoff_desc': 'Elimine cargos usando disputas de verificacion, validacion de cuentas y negociaciones con acreedores. Los cargos senalan morosidad severa a los prestamistas.',
    'home.issue_bankruptcy': 'Eliminacion de Bancarrota',
    'home.issue_bankruptcy_desc': 'Desafie errores de reporte de bancarrota y reconstruya su credito despues del Capitulo 7 o 13. Aunque las bancarrotas son dificiles de eliminar, los errores de reporte son comunes.',
    'home.issue_identity': 'Resolucion de Robo de Identidad',
    'home.issue_identity_desc': 'Proceso experto de bloqueo de credito FCRA 605B para victimas de fraude. Elimine cuentas fraudulentas y restaure su credito usando procedimientos especializados.',
    'home.issue_inquiry': 'Eliminacion de Consultas Duras',
    'home.issue_inquiry_desc': 'Elimine consultas duras no autorizadas que no fueron aprobadas por usted. Cada consulta puede costar 5-10 puntos, y multiples consultas agravan el dano.',
    'home.learn_more': 'Saber Mas',
    'home.process_title': 'Nuestro Proceso Probado de 6 Pasos',
    'home.process_desc': 'Hemos perfeccionado nuestro proceso de reparacion de credito durante 16+ anos para entregar resultados maximos a nuestros clientes.',
    'home.ps1_title': 'Analisis de Credito Gratuito',
    'home.ps1_desc': 'Revision completa del reporte de credito para identificar todos los elementos negativos y oportunidades de mejora.',
    'home.ps2_title': 'Estrategia Personalizada',
    'home.ps2_desc': 'Estrategia de disputa personalizada usando IA avanzada y tecnicas de cumplimiento Metro2.',
    'home.ps3_title': 'Disputas Profesionales',
    'home.ps3_desc': 'Cartas de disputa expertas enviadas a las agencias de credito y acreedores en su nombre.',
    'home.ps4_title': 'Desafios a las Agencias',
    'home.ps4_desc': 'Desafios estrategicos a las tres agencias de credito usando metodos legales probados.',
    'home.ps5_title': 'Seguimiento del Progreso',
    'home.ps5_desc': 'Actualizaciones en tiempo real a traves de nuestra app de Rastreo de Credito mostrando sus puntajes en mejora.',
    'home.ps6_title': 'Optimizacion del Puntaje',
    'home.ps6_desc': 'Optimizacion continua y estrategias de construccion de credito para exito a largo plazo.',
    'home.testimonials_title': 'Resultados Reales de Clientes Reales',
    'home.testimonials_desc': 'No solo tome nuestra palabra. Vea lo que nuestros clientes dicen sobre su viaje de reparacion de credito.',
    'home.before': 'Antes',
    'home.after': 'Despues',
    'home.read_story': 'Leer Historia Completa',
    'home.local_title': 'Servicios de Reparacion de Credito en Filadelfia y Todo el Pais',
    'home.local_desc': 'Desde 2008, Credlocity ha operado desde nuestra sede en Filadelfia, Pennsylvania, brindando servicios profesionales de reparacion de credito a clientes en los 50 estados. Como empresa de propiedad hispana fundada por el CEO Joeziel Vazquez, estamos orgullosos de servir a comunidades diversas con servicios eticos y compatibles de restauracion de credito.',
    'home.serving_markets': 'Sirviendo a Estos Mercados Principales:',
    'home.get_started_online': 'Comience en Linea',
    'home.philly_hq': 'Sede en Filadelfia',
    'home.serving_50': 'Sirviendo a los 50 estados a nivel nacional',
    'home.email_support': 'Soporte por Email',
    'home.tsr_compliant': 'Compatible con TSR',
    'home.tsr_online': '100% inscripcion en linea - Sin llamadas telefonicas requeridas',
    'home.signup_anytime': 'Registrese en Cualquier Momento',
    'home.247_enrollment': 'Inscripcion en linea 24/7 disponible',
    'home.start_trial_online': 'Inicie Su Prueba Gratis en Linea',
    'home.faq_title': 'Preguntas Frecuentes Sobre Reparacion de Credito',
    'home.faq_desc': 'Obtenga respuestas a las preguntas mas frecuentes sobre nuestros servicios de reparacion de credito.',
    'home.faq1_q': 'Cuanto tiempo toma la reparacion de credito?',
    'home.faq1_a': 'La mayoria de los clientes ven resultados en 60-90 dias, con mejoras significativas a los 6 meses. El plazo depende del numero y tipo de elementos negativos. Los cobros y pagos atrasados se eliminan mas rapido que las bancarrotas o sentencias. Las agencias de credito tienen 30 dias para investigar disputas bajo FCRA.',
    'home.faq2_q': 'Realmente pueden eliminar elementos negativos de mi reporte de credito?',
    'home.faq2_a': 'Si, pero solo elementos inexactos, inverificables o que violen leyes de proteccion al consumidor. Informacion negativa legitima que los acreedores puedan verificar puede permanecer. Sin embargo, muchos elementos negativos contienen errores o violaciones que los hacen legalmente eliminables bajo FCRA, FDCPA o FCBA.',
    'home.faq3_q': 'Cuanto cuesta la reparacion de credito?',
    'home.faq3_a': 'La reparacion de credito tipicamente cuesta $79-$149 por mes. Credlocity ofrece una prueba gratis de 30 dias sin cargos de servicio por adelantado. Solo paga por servicios requeridos: analisis de reporte de credito ($49.95) y poder notarial e-notario ($39.95). Despues de su prueba gratis, el servicio mensual es $99/mes con nuestra garantia de devolucion de 180 dias.',
    'home.faq4_q': 'Es legal la reparacion de credito?',
    'home.faq4_a': 'Si. La reparacion de credito es 100% legal bajo la Ley de Organizaciones de Reparacion de Credito (CROA). Usted tiene el derecho de disputar informacion inexacta bajo la Ley de Informes de Credito Justos (FCRA). Empresas de renombre como Credlocity operan en cumplimiento total con regulaciones federales incluyendo TSR y CROA.',
    'home.faq5_q': 'La reparacion de credito danara mi puntaje?',
    'home.faq5_a': 'No. Disputar elementos no puede danar su puntaje de credito. Si una disputa es exitosa, los elementos negativos se eliminan y su puntaje mejora. Si no tiene exito, su credito permanece igual. No hay desventaja en disputas legitimas de reparacion de credito.',
    'home.faq_more': 'Tiene mas preguntas? Visite nuestra pagina completa de preguntas frecuentes con mas de 50 respuestas.',
    'home.view_all_faqs': 'Ver Todas las Preguntas',
    'home.cta_title': 'Listo Para Tomar Control de Su Credito?',
    'home.cta_desc': 'Inicie su prueba gratis de 30 dias hoy. Sin tarjeta de credito requerida. Sin cargo inicial. Cancele en cualquier momento.',
    'home.cta_trial': 'Inicie Su Prueba Gratis',
    'home.cta_consult': 'Reserve una Consulta',

    // Public website
    'site.home': 'Inicio',
    'site.about': 'Acerca de',
    'site.about_us': 'Sobre Nosotros',
    'site.services': 'Servicios',
    'site.resources': 'Recursos',
    'site.contact': 'Contacto',
    'site.login': 'Iniciar Sesion',
    'site.get_started': 'Comenzar',
    'site.learn_more': 'Saber Mas',
    'site.credit_repair': 'Reparacion de Credito',
    'site.debt_collection': 'Cobro de Deudas',
    'site.legal_services': 'Servicios Legales',
    'site.education': 'Educacion',
    'site.blog': 'Blog',
    'site.faq': 'Preguntas Frecuentes',
    'site.privacy_policy': 'Politica de Privacidad',
    'site.terms_of_service': 'Terminos de Servicio',
    'site.all_rights_reserved': 'Todos los derechos reservados',
    'site.plans_pricing': 'Planes y Precios',
    'site.why_us': 'Por Que Nosotros',
    'site.free_trial': 'Prueba Gratis de 30 Dias',
    'site.collection_removal': 'Eliminacion de Cobros',
    'site.late_payment_removal': 'Eliminacion de Pagos Atrasados',
    'site.fraud_removal': 'Eliminacion de Fraude',
    'site.human_trafficking_block': 'Bloqueo de Credito por Trafico Humano',
    'site.how_it_works': 'Como Funciona',
    'site.faqs': 'Preguntas Frecuentes',
    'site.our_team': 'Nuestro Equipo',
    'site.educational_guides': 'Guias Educativas',
    'site.credit_repair_scams': 'Info de Estafas de Credito',
    'site.credit_tracker': 'App de Seguimiento de Credito',
    'site.start_free_trial': 'Iniciar Prueba Gratis',

    // Footer
    'footer.tagline': 'La Empresa de Reparacion de Credito Mas Confiable de America',
    'footer.credit_education': 'Educacion de Credito',
    'footer.credit_scores': 'Puntajes de Credito',
    'footer.credit_reports': 'Reportes de Credito',
    'footer.repair_methods': 'Metodos de Reparacion',
    'footer.debt_management': 'Gestion de Deudas',
    'footer.credit_building': 'Construccion de Credito',
    'footer.financial_wellness': 'Bienestar Financiero',
    'footer.education_hub': 'Centro Educativo',
    'footer.fcra_guide': 'Guia FCRA',
    'footer.fdcpa_guide': 'Guia FDCPA',
    'footer.croa_guide': 'Guia CROA',
    'footer.tsr_compliance': 'Cumplimiento TSR',
    'footer.fcra_605b': 'Bloqueo FCRA 605B',
    'footer.vs_competitors': 'Credlocity vs. Competidores',
    'footer.credit_repair_reviews': 'Resenas de Reparacion de Credito',
    'footer.why_us_over_them': 'Por Que Nosotros Sobre Ellos',
    'footer.credlocity': 'Credlocity',
    'footer.success_stories': 'Historias de Exito',
    'footer.lawsuits_filed': 'Demandas Presentadas',
    'footer.press_releases': 'Comunicados de Prensa',
    'footer.credlocity_partners': 'Socios de Credlocity',
    'footer.become_partner': 'Ser Socio',
    'footer.outsourcing_services': 'Servicios de Subcontratacion',
    'footer.credit_tools': 'Herramientas de Credito',
    'footer.credit_score_calc': 'Calculadora de Puntaje',
    'footer.dti_calc': 'Calculadora Deuda-Ingreso',
    'footer.utilization_calc': 'Calculadora de Utilizacion',
    'footer.loan_calc': 'Calculadora de Prestamos',
    'footer.debt_payoff_calc': 'Calculadora de Pago de Deuda',
    'footer.mortgage_calc': 'Calculadora de Hipoteca',
    'footer.cc_payoff_calc': 'Calculadora de Tarjeta de Credito',
    'footer.savings_calc': 'Calculadora de Ahorros',
    'footer.interest_calc': 'Calculadora de Intereses',
    'footer.budget_calc': 'Calculadora de Presupuesto',
    'footer.refinance_calc': 'Calculadora de Refinanciamiento',
    'footer.student_loan_calc': 'Calculadora de Prestamo Estudiantil',
    'footer.auto_loan_calc': 'Calculadora de Prestamo de Auto',
    'footer.retirement_calc': 'Calculadora de Jubilacion',
    'footer.consumer_protection': 'Proteccion al Consumidor',
    'footer.report_fraud': 'Reportar Fraude',
    'footer.report_fraud_desc': 'Fiscal General del Estado o asuntos del consumidor local',
    'footer.ftc_complaints': 'Quejas de la FTC',
    'footer.unfair_treatment': 'Trato Injusto',
    'footer.unfair_treatment_desc': 'Contacte al Fiscal General de PA',
    'footer.honest_fair_legal': 'Honesto, Justo y Legal',
    'footer.important_disclosure': 'DIVULGACION IMPORTANTE',
    'footer.your_rights': 'Sus Derechos',
    'footer.your_rights_desc': 'Puede disputar errores en su reporte de credito de forma gratuita bajo la Ley de Informes de Credito Justos (FCRA). Credlocity no brinda asesoramiento legal ni garantiza la eliminacion de elementos verificables.',
    'footer.requirements': 'Requisitos',
    'footer.requirements_desc': 'Se requiere participacion activa del cliente. Los resultados pueden variar. Cumplimos con todas las leyes federales y estatales de reparacion de credito.',
    'footer.tsr_compliance_title': 'Cumplimiento TSR',
    'footer.tsr_compliance_desc': 'Cumplimiento total con CROA y la Regla de Ventas de Telemarketing.',
    'footer.federal_notice': 'Aviso Federal',
    'footer.federal_notice_desc': 'Todos los servicios se inician a traves de la plataforma en linea segura. Segun regulaciones federales, no hay inscripcion por telefono.',
    'footer.our_promise': 'Nuestra Promesa',
    'footer.our_promise_desc': 'Comprometidos con practicas eticas y transparencia total en todos nuestros servicios.',
    'footer.report_fraud_title': 'Reportar Fraude',
    'footer.report_fraud_question': 'Tuvo una mala experiencia con otra empresa de reparacion de credito?',
    'footer.submit_complaint': 'Enviar una Queja',
    'footer.copyright': '2026 Credlocity Business Group LLC. Todos los derechos reservados.',
    'footer.serving': 'Sirviendo a los 50 Estados desde Filadelfia, PA',

    // Login pages — shared
    'login.email': 'Correo Electrónico',
    'login.password': 'Contraseña',
    'login.sign_in': 'Iniciar Sesión',
    'login.signing_in': 'Iniciando sesión...',
    'login.forgot_password': '¿Olvidó su contraseña?',
    'login.remember_me': 'Recordarme',
    'login.send_reset': 'Enviar Email de Restablecimiento',
    'login.sending': 'Enviando...',
    'login.reset_sent': 'Si ese correo existe, se envió un enlace de restablecimiento.',
    'login.back_to_login': '← Volver al inicio de sesión',
    'login.back_to_home': 'Volver a Credlocity',

    // CRO login
    'cro.portal_title': 'Portal de Socios CRO',
    'cro.portal_subtitle': 'Inicia sesión para gestionar tus casos y ganancias',
    'cro.not_partner': '¿Aún no eres socio?',
    'cro.apply_network': 'Solicitar unirse a nuestra red',
    'cro.forgot_desc': 'Ingresa el correo de tu cuenta CRO y te enviaremos una contraseña temporal.',

    // CRO Dashboard
    'cro.dashboard.welcome_back': 'Bienvenido de nuevo',
    'cro.dashboard.overview': 'Aquí está tu resumen de asociación CRO.',
    'cro.showcase.eyebrow': 'Recuperado para clientes',
    'cro.showcase.label': 'Total recuperado para sus clientes',
    'cro.showcase.sub_one': 'En 1 caso resuelto',
    'cro.showcase.sub_many': 'En {count} casos resueltos',
    'cro.showcase.empty_headline': 'Recuperando dinero para sus clientes',
    'cro.showcase.empty_sub': 'Las recuperaciones de sus clientes aparecerán aquí a medida que se resuelvan sus casos.',
    'cro.dashboard.total_cases': 'Casos Totales',
    'cro.dashboard.all_submissions': 'Todos los envíos',
    'cro.dashboard.active_cases': 'Casos Activos',
    'cro.dashboard.in_marketplace': 'En el mercado',
    'cro.dashboard.total_earnings': 'Ganancias Totales',
    'cro.dashboard.all_time': 'Historial completo',
    'cro.dashboard.pending_payouts': 'Pagos Pendientes',
    'cro.dashboard.processing': 'En proceso',
    'cro.dashboard.rejected_cases': 'Casos Rechazados',
    'cro.dashboard.unread_messages': 'Mensajes Sin Leer',
    'cro.dashboard.recent_cases': 'Casos Recientes',
    'cro.dashboard.latest_submissions': 'Tus últimos envíos de casos',
    'cro.dashboard.view_all': 'Ver Todos',
    'cro.dashboard.no_cases': 'Aún no hay casos enviados',
    'cro.dashboard.submit_first': 'Envía Tu Primer Caso',
    'cro.dashboard.quick_actions': 'Acciones Rápidas',
    'cro.dashboard.submit_new_case': 'Enviar Nuevo Caso',
    'cro.dashboard.track_cases': 'Rastrear Mis Casos',
    'cro.dashboard.view_earnings': 'Ver Ganancias',
    'cro.dashboard.messages': 'Mensajes',
    'cro.dashboard.case_pipeline': 'Pipeline de Casos',
    'cro.dashboard.pending_review': 'Pendiente de Revisión',
    'cro.dashboard.listed_bidding': 'Listado / En Puja',
    'cro.dashboard.pledged': 'Comprometido',
    'cro.dashboard.awarded': 'Adjudicado',
    'cro.dashboard.est_value': 'Valor Est.:',
    'cro.dashboard.view': 'Ver',
    'cro.dashboard.error': 'Error',
    'cro.dashboard.try_again': 'Intentar de Nuevo',
    'cro.dashboard.cro_portal': 'Portal CRO',
    'cro.dashboard.account_settings': 'Configuración de Cuenta',
    'cro.dashboard.subscription': 'Suscripción',
    'cro.dashboard.logout': 'Cerrar Sesión',
    'cro.dashboard.how_it_works': 'Cómo Funciona',

    // CRO Fee Agreement Modal
    'cro.agreement.title': 'Acuerdo de Socio CRO v2.0',
    'cro.agreement.subtitle': 'Revisa y firma para acceder a tu portal',
    'cro.agreement.sign_label': 'Escribe tu nombre completo para firmar',
    'cro.agreement.sign_placeholder': 'ej. Jane M. Smith',
    'cro.agreement.signing': 'Firmando...',
    'cro.agreement.agree_sign': 'Acepto y Firmo',
    'cro.agreement.failed': 'Error al enviar. Por favor intenta de nuevo.',
    'cro.agreement.network_error': 'Error de red. Por favor intenta de nuevo.',

    // CRO How It Works Modal
    'cro.how.title': 'Cómo Funciona el Mercado de Abogados para Ti',
    'cro.how.platform_access': 'Tarifas de Acceso a la Plataforma',
    'cro.how.platform_fee_detail': 'Tarifa única de registro: {signup} ({waiver} para clientes activos de subcontratación con {threshold}+ consumidores inscritos). Tarifa mensual: {monthly}/mes, que comienza después de un período gratuito de {new_free_days} días (los clientes de subcontratación con {threshold}+ consumidores inscritos obtienen {partner_free_days} días gratis).',
    'cro.how.submitting_cases': 'Envío de Casos',
    'cro.how.submitting_detail': 'Desde tu panel, envía casos de consumidores al Mercado de Abogados de Credlocity. Tú estableces el monto de compromiso del abogado ($300–$600). El administrador de Credlocity revisa y puede ajustarlo antes de publicar el caso.',
    'cro.how.your_earnings': 'Tus Ganancias',
    'cro.how.earnings_detail': 'Cuando un abogado toma tu caso, recibes la tarifa de compromiso del caso menos una tarifa de conveniencia fija de Credlocity determinada por el nivel de valor del caso — nunca un porcentaje de ningún acuerdo. Los pagos se procesan 15 días después de que se asigna el caso.',
    'cro.how.pledge_negotiation': 'Negociación de Compromiso',
    'cro.how.pledge_detail': 'Si un abogado ofrece menos de tu monto deseado, serás notificado y podrás aceptar o rechazar. Si rechazas, el abogado tiene 8 horas para revisar antes de que el caso vuelva al mercado abierto.',
    'cro.how.close': 'Cerrar',

    // CRO Case Submit
    'cro.submit.title': 'Enviar Nuevo Caso',
    'cro.submit.subtitle': 'Envía un caso de cliente al Mercado de Abogados de Credlocity',
    'cro.submit.strength_title': 'Indicador de Fortaleza del Caso',
    'cro.submit.client_info': 'Información del Cliente',
    'cro.submit.client_name': 'Nombre del Cliente *',
    'cro.submit.client_name_placeholder': 'Nombre legal completo',
    'cro.submit.client_state': 'Estado del Cliente *',
    'cro.submit.select_state': 'Seleccionar estado',
    'cro.submit.client_email': 'Correo del Cliente',
    'cro.submit.client_email_placeholder': 'cliente@correo.com',
    'cro.submit.client_phone': 'Teléfono del Cliente',
    'cro.submit.client_phone_placeholder': '(555) 123-4567',
    'cro.submit.dispute_dates_tracking': 'Fechas de Disputa y Rastreo',
    'cro.submit.dispute_dates': 'Fechas de Disputas Enviadas *',
    'cro.submit.add_date': 'Agregar Fecha',
    'cro.submit.mail_method': 'Método de Envío *',
    'cro.submit.regular_mail': 'Correo Regular',
    'cro.submit.certified_mail': 'Correo Certificado',
    'cro.submit.credit_bureau': 'Agencia de Crédito *',
    'cro.submit.select_bureau': 'Seleccionar agencia',
    'cro.submit.tracking_numbers': 'Números de Rastreo de Correo Certificado',
    'cro.submit.tracking_placeholder': 'ej. 7019 1640 0000 0000 0000',
    'cro.submit.add_tracking': 'Agregar Número de Rastreo',
    'cro.submit.violation_info': 'Información de la Violación',
    'cro.submit.violation_type': 'Tipo de Violación *',
    'cro.submit.select_violation': 'Seleccionar violación',
    'cro.submit.violation_count': 'Número de Violaciones *',
    'cro.submit.bureau_responses': 'Respuestas de la Agencia Recibidas',
    'cro.submit.doc_quality': 'Calidad de la Documentación',
    'cro.submit.standard': 'Estándar',
    'cro.submit.good': 'Bueno',
    'cro.submit.excellent': 'Excelente',
    'cro.submit.violation_details': 'Detalles de la Violación',
    'cro.submit.violation_details_placeholder': 'Describa las violaciones en detalle...',
    'cro.submit.supporting_docs': 'Documentos de Apoyo',
    'cro.submit.docs_subtitle': 'Sube PDFs de cartas enviadas, reportes de crédito y otras evidencias. Máximo 10MB por archivo.',
    'cro.submit.choose_file': 'Elegir Archivo',
    'cro.submit.uploading': 'Subiendo...',
    'cro.submit.class_action': 'Acción Colectiva (Opcional)',
    'cro.submit.class_action_check': 'Este caso involucra una posible acción colectiva',
    'cro.submit.affected_consumers': 'Número Estimado de Consumidores Afectados',
    'cro.submit.class_action_note': 'Los casos con 50+ consumidores afectados califican para ventana de puja extendida (21 días)',
    'cro.submit.case_summary': 'Resumen del Caso',
    'cro.submit.case_summary_placeholder': 'Proporciona un resumen del caso para los abogados revisores...',
    'cro.submit.pledge_amount': 'Monto de Compromiso Deseado',
    'cro.submit.pledge_desc': 'Establece la tarifa de compromiso del abogado para este caso ($300–$600). El administrador de Credlocity puede ajustar esto antes de publicar el caso.',
    'cro.submit.pledge_standard': '$300 (estándar)',
    'cro.submit.pledge_premium': '$600 (premium)',
    'cro.submit.important': 'Importante',
    'cro.submit.important_desc': 'Los casos se revisan en 24-48 horas. Una vez aprobados, se listarán en el Mercado de Abogados. En cada caso que un abogado tome, recibes la tarifa de compromiso menos una tarifa de conveniencia fija de Credlocity — nunca un porcentaje de ningún acuerdo. Los abogados solo verán metadatos del caso hasta que comprometan — la información de contacto de tu cliente y los documentos subidos permanecen protegidos.',
    'cro.submit.submitting': 'Enviando...',
    'cro.submit.submit_case': 'Enviar Caso',
    'cro.submit.success_title': '¡Caso Enviado!',
    'cro.submit.case_number': 'Número de Caso:',
    'cro.submit.estimated_value': 'Valor Estimado:',
    'cro.submit.case_strength': 'Fortaleza del Caso:',
    'cro.submit.qualifies_bidding': '¡Este caso califica para puja competitiva!',
    'cro.submit.review_note': 'Tu caso será revisado por nuestro equipo en 24-48 horas.',
    'cro.submit.submit_another': 'Enviar Otro Caso',
    'cro.submit.view_tracker': 'Ver Rastreador de Casos',

    // CRO Subscription
    'cro.subscription.title': 'Gestión de Suscripción',
    'cro.subscription.account_suspended': 'Cuenta Suspendida',
    'cro.subscription.suspended_msg': 'Tu cuenta ha sido suspendida. Contacta a soporte para más información.',
    'cro.subscription.lapsed': 'Suscripción Vencida',
    'cro.subscription.lapsed_msg': 'Tu suscripción ha vencido. Los listados de casos existentes permanecen activos, pero no puedes enviar nuevos casos hasta que renueves.',
    'cro.subscription.renew': 'Renovar Suscripción',
    'cro.subscription.plan_title': 'Plan de Asociación CRO',
    'cro.subscription.plan_desc': '{monthly}/mes a través de Goat Payments (tasa combinada del 3.98%)',
    'cro.subscription.signup_fee': 'Tarifa Única de Registro',
    'cro.subscription.paid': 'Pagado',
    'cro.subscription.pay_now': 'Pagar Ahora',
    'cro.subscription.monthly_sub': 'Suscripción Mensual',
    'cro.subscription.active': 'Activa',
    'cro.subscription.inactive': 'Inactiva',
    'cro.subscription.started': 'Suscripción Iniciada',
    'cro.subscription.next_renewal': 'Próxima Renovación',
    'cro.subscription.cases_submitted': 'Casos Enviados',
    'cro.subscription.fees_earned': 'Tarifas Ganadas',
    'cro.subscription.chargebacks': 'Contracargos',
    'cro.subscription.subscribe': 'Suscribirse',
    'cro.subscription.benefits_title': 'La Suscripción Activa Desbloquea:',
    'cro.subscription.benefit_1': 'Envíos ilimitados de casos al Mercado de Abogados',
    'cro.subscription.benefit_2': 'La tarifa de compromiso de cada caso tomado, menos una tarifa de conveniencia fija de Credlocity',
    'cro.subscription.benefit_3': 'Acceso al Panel de Pagos con ganancias en tiempo real',
    'cro.subscription.benefit_4': 'Seguimiento del estado de todos los casos enviados',
    'cro.subscription.benefit_5': 'Agregar notas o evidencia adicional a casos abiertos',
    'cro.subscription.benefit_6': 'Conteos de vistas en cada listado de caso (cuántos abogados vieron)',
    'cro.subscription.secure_payments': 'Pagos Seguros a través de Goat Payments',
    'cro.subscription.payment_desc': 'Todos los pagos de suscripción se procesan a través de Goat Payments con una tasa combinada del 3.98%. Tu información de pago está encriptada y segura.',
    'cro.subscription.pay_signup': 'Pagar Tarifa de Registro',
    'cro.subscription.subscribe_monthly': 'Suscribirse Mensualmente',
    'cro.subscription.one_time_fee': 'Tarifa Única de Registro',
    'cro.subscription.processing': 'Procesamiento (3.98%)',
    'cro.subscription.total': 'Total',
    'cro.subscription.coupon_discount': 'Descuento de Cupón',
    'cro.subscription.have_coupon': '¿Tienes un código de cupón?',
    'cro.subscription.enter_coupon': 'Ingresa el código de cupón',
    'cro.subscription.apply': 'Aplicar',
    'cro.subscription.free_months': 'mes gratis aplicado — facturación extendida.',
    'cro.subscription.free_months_plural': 'meses gratis aplicados — facturación extendida.',
    'cro.subscription.cardholder_name': 'Nombre del Titular',
    'cro.subscription.card_number': 'Número de Tarjeta',
    'cro.subscription.mm_yy': 'MM/AA',
    'cro.subscription.cvv': 'CVV',
    'cro.subscription.secured_by': 'Asegurado por Goat Payments | Tasa combinada del 3.98%',
    'cro.subscription.processing_payment': 'Procesando...',
    'cro.subscription.pay': 'Pagar',

    // CRO Case Tracker
    'cro.tracker.title': 'Rastreador de Casos',
    'cro.tracker.total_cases': 'casos en total',
    'cro.tracker.refresh': 'Actualizar',
    'cro.tracker.search_placeholder': 'Buscar por nombre o número de caso...',
    'cro.tracker.no_cases': 'No se encontraron casos',
    'cro.tracker.all_statuses': 'Todos los Estados',
    'cro.tracker.pending_review': 'Pendiente de Revisión',
    'cro.tracker.approved': 'Aprobado',
    'cro.tracker.listed': 'Listado',
    'cro.tracker.pledged': 'Comprometido',
    'cro.tracker.bidding': 'En Puja',
    'cro.tracker.awarded': 'Adjudicado',
    'cro.tracker.completed': 'Completado',
    'cro.tracker.rejected': 'Rechazado',
    'cro.tracker.bidding_eligible': 'Apto para Puja',
    'cro.tracker.class_action': 'Acción Colectiva',
    'cro.tracker.state': 'Estado',
    'cro.tracker.mail_method': 'Método de Envío',
    'cro.tracker.violations': 'Violaciones',
    'cro.tracker.doc_quality': 'Calidad de la Documentación',
    'cro.tracker.dispute_date': 'Fecha de Disputa',
    'cro.tracker.pledge_fee': 'Tarifa de Compromiso',
    'cro.tracker.assigned_attorney': 'Abogado Asignado',
    'cro.tracker.winning_bid': 'Puja Ganadora',
    'cro.tracker.your_payout': 'Tu Pago',
    'cro.tracker.case_summary': 'Resumen del Caso',
    'cro.tracker.est': 'Est.',

    // CRO Messages
    'cro.messages.title': 'Mensajes',
    'cro.messages.conversations': 'Conversaciones',
    'cro.messages.no_conversations': 'Aún no hay conversaciones',
    'cro.messages.no_conversations_desc': 'Los mensajes aparecen cuando un abogado compromete tu caso',
    'cro.messages.select_conversation': 'Selecciona una conversación',
    'cro.messages.select_desc': 'Elige de la lista para ver los mensajes',
    'cro.messages.type_message': 'Escribe tu mensaje...',
    'cro.messages.attorney': 'Abogado',

    // CRO Payout Dashboard
    'cro.payouts.title': 'Panel de Pagos',
    'cro.payouts.pending_balance': 'Saldo Pendiente',
    'cro.payouts.approved_balance': 'Saldo Aprobado',
    'cro.payouts.lifetime_paid': 'Total Pagado',
    'cro.payouts.total_cases': 'Casos Totales',
    'cro.payouts.payout_history': 'Historial de Pagos',
    'cro.payouts.no_payouts': 'Aún no hay pagos. Envía casos y gana cuando los abogados comprometan o pujen.',
    'cro.payouts.case': 'Caso',
    'cro.payouts.pledge_fee': 'Tarifa de Compromiso',
    'cro.payouts.convenience_fee': 'Tarifa de Conveniencia',
    'cro.payouts.transaction_fee': 'Tarifa de Transacción',
    'cro.payouts.your_share': 'Tu Parte',
    'cro.payouts.price_range': 'Tu Precio',
    'cro.payouts.you_receive': 'Recibes',
    'cro.payouts.share_note': 'Tu parte = el precio que fijaste para el caso (el monto de tu control deslizante) menos una tarifa de conveniencia fija de Credlocity y una pequeña tarifa de transacción (un porcentaje fijo). Nunca un porcentaje de ningún acuerdo.',
    'cro.payouts.earned': 'Ganado',
    'cro.payouts.earliest_payout': 'Pago Más Temprano',
    'cro.payouts.status': 'Estado',
    'cro.payouts.case_views': 'Vistas del Listado de Caso',
    'cro.payouts.no_cases': 'Aún no hay casos enviados',

    // CRO Earnings
    'cro.earnings.title': 'Rastreador de Ganancias',
    'cro.earnings.subtitle': 'Rastrea tus pagos de compromisos y pujas de abogados',
    'cro.earnings.refresh': 'Actualizar',
    'cro.earnings.lifetime': 'Ganancias Totales',
    'cro.earnings.pending': 'Pagos Pendientes',
    'cro.earnings.total_payouts': 'Total de Pagos',
    'cro.earnings.payout_history': 'Historial de Pagos',
    'cro.earnings.payout_desc': 'Todos los pagos de compromisos y adjudicaciones de abogados',
    'cro.earnings.date': 'Fecha',
    'cro.earnings.case': 'Caso',
    'cro.earnings.type': 'Tipo',
    'cro.earnings.amount': 'Monto',
    'cro.earnings.status': 'Estado',
    'cro.earnings.paid': 'Pagado',
    'cro.earnings.pending_status': 'Pendiente',
    'cro.earnings.no_payouts': 'Aún no hay pagos',
    'cro.earnings.no_payouts_desc': 'Envía casos y gana la tarifa de compromiso (menos una tarifa de conveniencia fija) cuando los abogados los tomen',
    'cro.earnings.how_title': 'Cómo Funcionan las Ganancias',
    'cro.earnings.how_1': 'Cuando un abogado toma tu caso, paga una tarifa de compromiso fija determinada por el nivel de valor del caso',
    'cro.earnings.how_2': 'Recibes esa tarifa de compromiso menos una tarifa de conveniencia fija de Credlocity — nunca un porcentaje de ningún acuerdo',
    'cro.earnings.how_3': 'Para casos de puja, el mismo modelo de tarifa de compromiso fija aplica al caso que toma el abogado ganador',
    'cro.earnings.how_4': 'Los pagos se procesan 15 días después de que se asigna un caso',

    // CRO Team Management
    'cro.team.title': 'Gestión del Equipo',
    'cro.team.subtitle': 'Los miembros del equipo pueden enviar casos bajo tu organización.',
    'cro.team.add_member': 'Agregar Miembro',
    'cro.team.info': "Los miembros del equipo inician sesión en la misma URL del Portal CRO y pueden enviar casos, rastrear el estado y comunicarse con abogados — todo bajo la cuenta de tu organización.",
    'cro.team.members_title': 'Miembros del Equipo',
    'cro.team.no_members': 'Aún No Hay Miembros',
    'cro.team.no_members_desc': 'Agrega miembros para que puedan enviar casos bajo tu organización.',
    'cro.team.add_first': 'Agregar Primer Miembro',
    'cro.team.name': 'Nombre',
    'cro.team.email': 'Correo',
    'cro.team.role': 'Rol',
    'cro.team.status': 'Estado',
    'cro.team.added': 'Agregado',
    'cro.team.actions': 'Acciones',
    'cro.team.add_modal_title': 'Agregar Miembro del Equipo',
    'cro.team.full_name': 'Nombre Completo *',
    'cro.team.email_address': 'Correo Electrónico *',
    'cro.team.role_label': 'Rol *',
    'cro.team.role_member': 'Miembro — puede enviar y rastrear casos',
    'cro.team.role_manager': 'Gerente — acceso completo',
    'cro.team.welcome_email': 'Se enviará automáticamente un correo de bienvenida con una contraseña temporal.',
    'cro.team.adding': 'Agregando...',
    'cro.team.add_member_btn': 'Agregar Miembro',
    'cro.team.remove_confirm': 'Eliminar',
    'cro.team.from_team': 'del equipo?',

    // CRO Settings
    'cro.settings.title': 'Configuración de Cuenta',
    'cro.settings.company_info': 'Información de la Empresa',
    'cro.settings.company_desc': 'Actualiza los detalles de tu organización',
    'cro.settings.company_name': 'Nombre de la Empresa',
    'cro.settings.owner_name': 'Nombre del Propietario',
    'cro.settings.phone': 'Teléfono',
    'cro.settings.website': 'Sitio Web',
    'cro.settings.license_number': 'Número de Licencia',
    'cro.settings.email': 'Correo',
    'cro.settings.ein': 'EIN',
    'cro.settings.state': 'Estado',
    'cro.settings.referral_code': 'Código de Referido',
    'cro.settings.change_password': 'Cambiar Contraseña',
    'cro.settings.password_desc': 'Deja en blanco para mantener la contraseña actual',
    'cro.settings.current_password': 'Contraseña Actual',
    'cro.settings.new_password': 'Nueva Contraseña',
    'cro.settings.confirm_password': 'Confirmar Nueva Contraseña',
    'cro.settings.saving': 'Guardando...',
    'cro.settings.save_changes': 'Guardar Cambios',

    // CRO Change Password
    'cro.changepass.set_title': 'Establecer Contraseña',
    'cro.changepass.change_title': 'Cambiar Contraseña',
    'cro.changepass.set_desc': 'Por favor crea una nueva contraseña antes de continuar a tu portal.',
    'cro.changepass.change_desc': 'Actualiza tu contraseña del portal CRO.',
    'cro.changepass.current_password': 'Contraseña Actual',
    'cro.changepass.new_password': 'Nueva Contraseña',
    'cro.changepass.new_password_placeholder': 'Mínimo 8 caracteres',
    'cro.changepass.confirm_password': 'Confirmar Nueva Contraseña',
    'cro.changepass.confirm_placeholder': 'Vuelve a ingresar la contraseña',
    'cro.changepass.saving': 'Guardando...',
    'cro.changepass.set_new': 'Establecer Nueva Contraseña',
    'cro.changepass.success': 'Contraseña cambiada exitosamente. Redirigiendo...',
    'cro.changepass.min_chars': 'La contraseña debe tener al menos 8 caracteres',
    'cro.changepass.no_match': 'Las contraseñas no coinciden',
    'cro.changepass.failed': 'Error al cambiar la contraseña',
    'cro.changepass.connect_failed': 'Error al conectar con el servidor',

    // CRO Landing Page
    'cro.landing.badge': 'Programa de Asociación CRO',
    'cro.landing.hero_title': 'Convierte Tus Casos de Reparación de Crédito en Ingresos',
    'cro.landing.hero_desc': 'Envía tus casos de violaciones FCRA, FDCPA y TCPA a nuestro Mercado de Abogados. Cuando los abogados toman tus casos, ganas la tarifa de compromiso menos una tarifa de conveniencia fija — automáticamente.',
    'cro.landing.apply_now': 'Aplicar Ahora',
    'cro.landing.partner_login': 'Acceso de Socios',
    'cro.landing.revenue_share': 'Lo que toma Credlocity (nunca un % del acuerdo)',
    'cro.landing.pledge_fee': 'Tarifa de compromiso por caso',
    'cro.landing.payout_timeline': 'Plazo de Pago',
    'cro.landing.monthly_fee': 'Tarifa Mensual',
    'cro.landing.how_works_title': 'Cómo Funciona la Asociación CRO',
    'cro.landing.how_works_desc': 'Un proceso simple y transparente desde el envío del caso hasta el pago',
    'cro.landing.step': 'PASO',
    'cro.landing.step1_title': 'Enviar Casos',
    'cro.landing.step1_desc': 'Sube tus casos de disputa de consumidores con documentación de apoyo a nuestro mercado.',
    'cro.landing.step2_title': 'Revisión del Caso',
    'cro.landing.step2_desc': 'Nuestro equipo revisa y valora tu caso en 24-48 horas, luego lo lista para los abogados.',
    'cro.landing.step3_title': 'Acción del Abogado',
    'cro.landing.step3_desc': 'Los abogados comprometen o pujan por tu caso, pagando directamente a la plataforma.',
    'cro.landing.step4_title': 'Recibe tu Pago',
    'cro.landing.step4_desc': 'Recibes automáticamente la tarifa de compromiso del caso, menos una tarifa de conveniencia fija de Credlocity, 15 días después de que se asigna el caso.',
    'cro.landing.valuation_title': 'Sistema de Valoración de Casos',
    'cro.landing.valuation_desc': 'Los casos se valoran según múltiples factores que determinan su valor para los abogados',
    'cro.landing.val1_title': 'Cantidad de Violaciones',
    'cro.landing.val1_desc': 'Valor base de $1,000 por violación. Más violaciones = mayor valor del caso.',
    'cro.landing.val2_title': 'Método de Envío',
    'cro.landing.val2_desc': 'Los casos con correo certificado reciben un multiplicador de 1.5x sobre el correo regular.',
    'cro.landing.val3_title': 'Calidad de la Documentación',
    'cro.landing.val3_desc': 'La documentación excelente agrega un multiplicador de 1.3x; la buena agrega 1.1x.',
    'cro.landing.val4_title': 'Respuestas de la Agencia',
    'cro.landing.val4_desc': 'Cada respuesta de agencia recibida agrega $500 al valor del caso.',
    'cro.landing.pledge_vs_bid': 'Compromiso vs. Puja Competitiva',
    'cro.landing.standard_pledge': 'Compromiso Estándar',
    'cro.landing.for_standard': 'Para casos de valor estándar',
    'cro.landing.pledge_b1': 'Tarifa de compromiso fija determinada por el nivel de valor del caso',
    'cro.landing.pledge_b2': 'Recibes la tarifa de compromiso menos una tarifa de conveniencia fija',
    'cro.landing.pledge_b3': 'Asignación inmediata de abogado',
    'cro.landing.pledge_b4': 'Mensajería directa se abre al instante',
    'cro.landing.comp_bidding': 'Puja Competitiva',
    'cro.landing.for_highval': 'Para casos de alto valor ($10K+ valor est.)',
    'cro.landing.bid_b1': 'Múltiples abogados compiten con pujas',
    'cro.landing.bid_b2': 'Recibes la tarifa de compromiso de la puja ganadora, menos una tarifa de conveniencia fija',
    'cro.landing.bid_b3': 'Ventana de puja de 14 días (21 para acción colectiva)',
    'cro.landing.bid_b4': 'Mayor potencial de ganancias por caso',
    'cro.landing.class_action_title': 'Casos de Acción Colectiva',
    'cro.landing.class_action_desc': 'Los casos con 50 o más consumidores afectados califican para estatus de acción colectiva, recibiendo ventanas de puja extendidas de 21 días y mayor visibilidad en el mercado. Los casos de acción colectiva suelen generar pujas significativamente más altas de los abogados.',
    'cro.landing.requirements_title': 'Requisitos de Asociación',
    'cro.landing.req_1': 'Organización de Reparación de Crédito registrada legalmente',
    'cro.landing.req_2': 'Número de Identificación del Empleador (EIN) válido',
    'cro.landing.req_3': 'Cumplimiento con CROA y todas las leyes aplicables',
    'cro.landing.req_4': 'Seguro de responsabilidad profesional',
    'cro.landing.req_5': 'Sin acciones regulatorias pendientes',
    'cro.landing.req_6': 'Documentación de casos precisa y completa',
    'cro.landing.req_7': 'Tarifa única de registro de {signup}',
    'cro.landing.req_8': 'Suscripción mensual de {monthly}',
    'cro.landing.enforcement_title': 'Política de Cumplimiento',
    'cro.landing.enforcement_desc': 'Mantenemos una política estricta para proteger a los consumidores y abogados',
    'cro.landing.first_strike': 'Primera Falta',
    'cro.landing.first_strike_desc': 'Advertencia escrita con detalles de la violación',
    'cro.landing.second_strike': 'Segunda Falta',
    'cro.landing.second_strike_desc': 'Suspensión de 30 días de la plataforma',
    'cro.landing.third_strike': 'Tercera Falta',
    'cro.landing.third_strike_desc': 'Eliminación permanente del Programa de Asociación CRO',
    'cro.landing.cta_title': '¿Listo para Asociarte con Credlocity?',
    'cro.landing.cta_desc': 'Únete a nuestra red y comienza a ganar con tus casos de reparación de crédito hoy.',
    'cro.landing.start_registration': 'Iniciar Registro',
    'cro.landing.registration_title': 'Registro de Asociación CRO',
    'cro.landing.participation_agreement': 'Acuerdo de Participación',
    'cro.landing.scroll_to_accept': 'Por favor desplázate por todo el acuerdo para aceptar',
    'cro.landing.i_agree': 'He leído y acepto el Acuerdo de Participación',
    'cro.landing.ip_notice': 'Al enviar este registro, tu dirección IP se registrará junto con tu aceptación del acuerdo para fines de cumplimiento legal y verificación.',
    'cro.landing.company_info': 'Información de la Empresa',
    'cro.landing.company_name': 'Nombre de la Empresa *',
    'cro.landing.company_placeholder': 'Nombre de tu empresa CRO',
    'cro.landing.owner_name': 'Nombre del Propietario / Principal *',
    'cro.landing.owner_placeholder': 'Nombre legal completo',
    'cro.landing.email': 'Correo *',
    'cro.landing.email_placeholder': 'negocio@empresa.com',
    'cro.landing.phone': 'Teléfono *',
    'cro.landing.phone_placeholder': '(555) 123-4567',
    'cro.landing.ein': 'EIN (Número de Identificación del Empleador) *',
    'cro.landing.ein_placeholder': 'XX-XXXXXXX',
    'cro.landing.state': 'Estado *',
    'cro.landing.select_state': 'Seleccionar estado',
    'cro.landing.license': 'Número de Licencia',
    'cro.landing.license_placeholder': 'Opcional',
    'cro.landing.website': 'Sitio Web',
    'cro.landing.website_placeholder': 'https://',
    'cro.landing.create_password': 'Crear Contraseña',
    'cro.landing.password': 'Contraseña *',
    'cro.landing.password_placeholder': 'Mín. 8 caracteres',
    'cro.landing.confirm_password': 'Confirmar Contraseña *',
    'cro.landing.confirm_placeholder': 'Vuelve a ingresar la contraseña',
    'cro.landing.reg_fees': 'Tarifas de Registro',
    'cro.landing.one_time_fee': 'Tarifa Única de Registro',
    'cro.landing.monthly_sub': 'Suscripción Mensual',
    'cro.landing.free_trial_included': ' días de prueba gratis incluidos!',
    'cro.landing.payment_note': 'El pago se procesará al enviar.',
    'cro.landing.promo_code': 'Código Promocional (Opcional)',
    'cro.landing.promo_placeholder': 'Ingresa el código promocional',
    'cro.landing.checking': 'Verificando...',
    'cro.landing.payment_info': 'Información de Pago',
    'cro.landing.card_number': 'Número de Tarjeta *',
    'cro.landing.expiration': 'Vencimiento (MMAA) *',
    'cro.landing.cvv': 'CVV *',
    'cro.landing.submitting': 'Enviando...',
    'cro.landing.submit_application': 'Enviar Solicitud',
    'cro.landing.already_partner': '¿Ya eres socio?',
    'cro.landing.sign_in': 'Inicia sesión aquí',
    'cro.landing.back_home': 'Volver a Credlocity',

    // CRO — newly added (full translation pass)
    'cro.dashboard.failed_load': 'No se pudo cargar el panel',
    'cro.dashboard.connect_failed': 'No se pudo conectar con el servidor',
    'cro.submit.doc_collection_agency': 'Carta a la Agencia de Cobranza',
    'cro.submit.doc_credit_bureau': 'Carta al Buró de Crédito',
    'cro.submit.doc_original_creditor': 'Carta al Acreedor Original',
    'cro.submit.doc_credit_report': 'Reporte de Crédito (Antes/Después)',
    'cro.submit.doc_other': 'Otro Documento de Respaldo',
    'cro.submit.factor_certified': 'Correo certificado utilizado',
    'cro.submit.factor_tracking': 'número(s) de rastreo',
    'cro.submit.factor_docs': 'documento(s) subido(s)',
    'cro.submit.factor_violations': 'infracción(es)',
    'cro.submit.factor_responses': 'respuesta(s) de buró',
    'cro.submit.factor_dates': 'fecha(s) de disputa',
    'cro.submit.strength_strong': 'Fuerte',
    'cro.submit.strength_moderate': 'Moderado',
    'cro.submit.strength_fair': 'Aceptable',
    'cro.submit.strength_weak': 'Débil',
    'cro.submit.toast_file_too_large': 'Archivo demasiado grande. Máximo 10MB.',
    'cro.submit.toast_file_type': 'Tipo de archivo no permitido:',
    'cro.submit.toast_uploaded': 'Subido:',
    'cro.submit.toast_upload_failed': 'Error al subir',
    'cro.submit.toast_upload_error': 'No se pudo subir el archivo',
    'cro.submit.toast_date_required': 'Se requiere al menos una fecha de disputa',
    'cro.submit.toast_success': '¡Caso enviado con éxito!',
    'cro.submit.toast_submit_failed': 'No se pudo enviar el caso',
    'cro.submit.toast_connect_failed': 'No se pudo conectar con el servidor',
    'cro.subscription.toast_load_failed': 'No se pudo cargar la información de suscripción',
    'cro.subscription.toast_coupon_applied': '¡Cupón aplicado!',
    'cro.subscription.toast_coupon_failed': 'No se pudo validar el cupón',
    'cro.subscription.invalid_coupon': 'Cupón inválido',
    'cro.subscription.toast_card_required': 'Por favor complete todos los datos de la tarjeta',
    'cro.subscription.toast_payment_failed': 'Pago rechazado',
    'cro.subscription.toast_payment_error': 'Error al procesar el pago',
    'cro.subscription.per_month': '/mes',
    'cro.subscription.processing_label': 'procesamiento',
    'cro.subscription.free_months_short': 'mes gratis aplicado',
    'cro.subscription.free_months_short_plural': 'meses gratis aplicados',
    'cro.subscription.discount_applied': 'de descuento aplicado',
    'cro.tracker.toast_load_failed': 'No se pudieron cargar los casos',
    'cro.messages.toast_load_failed': 'No se pudieron cargar los mensajes',
    'cro.messages.toast_send_failed': 'No se pudo enviar',
    'cro.messages.toast_send_error': 'No se pudo enviar el mensaje',
    'cro.payouts.toast_load_failed': 'No se pudo cargar el panel de pagos',
    'cro.earnings.toast_load_failed': 'No se pudieron cargar las ganancias',
    'cro.team.toast_load_failed': 'No se pudieron cargar los miembros del equipo',
    'cro.team.toast_connect_failed': 'No se pudo conectar con el servidor',
    'cro.team.toast_added': 'Miembro del equipo agregado — correo de bienvenida enviado',
    'cro.team.toast_add_failed': 'No se pudo agregar el miembro del equipo',
    'cro.team.toast_removed': 'Miembro del equipo eliminado',
    'cro.team.toast_remove_failed': 'No se pudo eliminar el miembro del equipo',
    'cro.team.email_placeholder': 'juan@ejemplo.com',
    'cro.settings.toast_load_failed': 'No se pudo cargar el perfil',
    'cro.settings.toast_no_match': 'Las contraseñas no coinciden',
    'cro.settings.toast_updated': 'Perfil actualizado',
    'cro.settings.toast_update_failed': 'No se pudo actualizar',
    'cro.settings.toast_save_failed': 'No se pudieron guardar los cambios',
    'cro.login.invalid_credentials': 'Credenciales inválidas',
    'cro.login.connect_failed': 'No se pudo conectar con el servidor',
    'cro.login.email_placeholder': 'cro@empresa.com',
    'cro.login.password_placeholder': 'Ingrese la contraseña',
    'cro.landing.free': 'GRATIS',
    'cro.landing.per_mo': '/mes',
    'cro.landing.toast_promo_applied': '¡Código promocional aplicado!',
    'cro.landing.toast_invalid_promo': 'Código promocional inválido',
    'cro.landing.toast_promo_failed': 'No se pudo validar el código',
    'cro.landing.toast_accept_agreement': 'Debe aceptar el acuerdo de participación',
    'cro.landing.toast_no_match': 'Las contraseñas no coinciden',
    'cro.landing.toast_min_chars': 'La contraseña debe tener al menos 8 caracteres',
    'cro.landing.toast_payment_required': 'Se requiere información de pago',
    'cro.landing.toast_reg_failed': 'Error en el registro',
    'cro.landing.toast_payment_failed': 'Pago rechazado — su registro fue guardado, por favor contacte a soporte.',
    'cro.landing.toast_reg_success': '¡Registro enviado! Su solicitud será revisada en 24-48 horas.',
    'cro.landing.toast_connect_failed': 'No se pudo conectar con el servidor',

    // CRO Messages Hub
    'cro.hub.support_tab': 'Soporte de Credlocity',
    'cro.hub.attorney_tab': 'Conversaciones con abogados',

    // Attorney login
    'attorney.portal_title': 'Portal de Abogados',
    'attorney.portal_subtitle': 'Inicia sesión para acceder a tus casos y el mercado',
    'attorney.not_registered': '¿Aún no estás registrado?',
    'attorney.apply_network': 'Solicitar unirse a nuestra red',
    'attorney.forgot_desc': 'Ingresa tu correo de abogado y te enviaremos una contraseña temporal.',

    // CRO Dashboard — new tile + greeting keys (Part 1 & 3)
    'cro.dash.greeting_eyebrow': 'Bienvenido de nuevo',
    'cro.dash.greeting': 'Hola, {name}',
    'cro.dash.hero_summary': '{pending} en el Mercado · {pledged} comprometidos',
    'cro.dash.submit_cta': 'Enviar un caso',
    'cro.dash.pending_title': 'Pendientes en el Mercado',
    'cro.dash.pending_cap': 'En vivo o esperando revisión',
    'cro.dash.pledged_title': 'Comprometidos',
    'cro.dash.pledged_cap': 'Un abogado ha tomado estos casos',
    'cro.dash.earned_title': 'Ganado para ti',
    'cro.dash.paid': 'Pagado',
    'cro.dash.pending_label': 'Pendiente',
    'cro.dash.recovered_title': 'Recuperado para tus clientes',
    'cro.dash.recovered_cap': 'De resultados reportados por abogados',
    'cro.dash.views_title': 'Vistas de casos',

    // CRO nav group headers (Part 2)
    'cro.navgroup.cases': 'Casos',
    'cro.navgroup.money': 'Dinero',
    'cro.navgroup.communication': 'Comunicación',
    'cro.navgroup.account': 'Cuenta',

    // CRO nav item labels not previously keyed
    'cro.nav.billing': 'Facturación',
    'cro.nav.book_call': 'Agendar Llamada',
    'cro.nav.add_documents': 'Agregar Documentos',

    // CRO Social Proof — nav + dashboard strip (cro.sp.*)
    'cro.sp.nav': 'Prueba Social',
    'cro.sp.page_title': 'Tarjetas de Prueba Social',
    'cro.sp.page_desc': 'Descarga tarjetas con tu marca para casos en los que un abogado ha aceptado o ganado.',
    'cro.sp.recent_wins_title': 'Victorias Recientes',
    'cro.sp.view_all': 'Ver todo',
    'cro.sp.new_win_banner': 'Nueva victoria — tu tarjeta de prueba social está lista',
    'cro.sp.badge_won': 'Caso Ganado',
    'cro.sp.badge_accepted': 'Caso Aceptado',
    'cro.sp.potential': 'potencial',
    'cro.sp.no_cards': 'Aún no hay tarjetas de prueba social',
    'cro.sp.no_cards_desc': 'Las tarjetas aparecen cuando un abogado acepta o gana uno de tus casos.',
    'cro.sp.sample_title': 'Así se verán tus tarjetas',
    'cro.sp.sample_desc': 'Tus tarjetas reales aparecerán aquí en cuanto un abogado tome uno de tus casos. Estas son muestras con tu marca.',
    'cro.sp.load_error': 'Error al cargar las tarjetas de prueba social',
    'cro.sp.size_square': 'Cuadrado (1080×1080)',
    'cro.sp.size_tall': 'Vertical (1080×1920)',
    'cro.sp.download': 'Descargar PNG',
    'cro.sp.consent_label': 'Mi cliente aceptó ser incluido en redes sociales',
    'cro.sp.consent_confirm': 'Confirmar y activar descarga',
    'cro.sp.consent_saving': 'Guardando...',
    'cro.sp.cors_warn': "El logo no se pudo incrustar por una restricción de origen. Cambia la marca de agua a 'Nombre de empresa' e inténtalo de nuevo.",
    'cro.sp.wm_title': 'Configuración de Marca de Agua',
    'cro.sp.wm_type_label': 'Tipo de marca de agua',
    'cro.sp.wm_logo': 'Logo',
    'cro.sp.wm_name': 'Nombre de empresa',
    'cro.sp.wm_strength_label': 'Intensidad',
    'cro.sp.wm_none': 'Ninguna',
    'cro.sp.wm_strong': 'Fuerte',
    'cro.sp.tracker_btn': 'Prueba Social',

    // Company pickers + violation questions (CompanyPicker.js, ViolationQuestions.js)
    'amp.company_picker.collector_label': 'Empresa Cobradora / Demandada',
    'amp.company_picker.bureau_label': 'Buró de Crédito',
    'amp.company_picker.select_placeholder': '— Seleccionar —',
    'amp.violation_questions.label': 'Detalles de Violaciones (marque todo lo que aplique)',
    'amp.violation_questions.loading': 'Cargando preguntas de violaciones…',
    'amp.violation_questions.fcra_heading': 'Violaciones FCRA',
    'amp.violation_questions.fdcpa_heading': 'Violaciones FDCPA',
  }
};

export function TranslationProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('credlocity_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('credlocity_lang', lang);
  }, [lang]);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.lang) setLang(e.detail.lang);
    };
    window.addEventListener('credlocity-lang-change', handler);
    return () => window.removeEventListener('credlocity-lang-change', handler);
  }, []);

  // t(key) returns the string for the active language (English fallback, then the raw key).
  // t(key, vars) additionally replaces {name} placeholders with vars.name — used so fee strings carry
  // the LIVE price (e.g. {signup}/{monthly} from /api/pricing/marketplace) instead of a typed number.
  // Backward compatible: with no vars, no replacement happens.
  const t = (key, vars) => {
    let s = translations[lang]?.[key] || translations.en[key] || key;
    if (vars && typeof s === 'string') {
      for (const name of Object.keys(vars)) {
        s = s.split('{' + name + '}').join(String(vars[name]));
      }
    }
    return s;
  };
  const toggleLang = () => setLang(prev => prev === 'en' ? 'es' : 'en');

  return (
    <TranslationContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(TranslationContext);
  if (!ctx) return { lang: 'en', setLang: () => {}, t: (k) => k, toggleLang: () => {} };
  return ctx;
}

export default TranslationContext;
